import {
  IconoirFilterList,
  IconoirNavArrowDown,
  IconoirNavArrowUp,
  IconoirPlus,
  IconoirTimer,
  IconoirCheck,
  IconoirXmark,
  IconoirHelpCircle,
  IconoirCustomExport,
  IconoirInfoCircle,
  IconoirMoreHoriz,
  IconoirArrowLeftCircle,
  IconoirArrowRightCircle,
  IconoirXmarkCircle,
  IconoirCheckCircle,
} from "@ey-xd/motif-icon";
import {
  MotifBadge,
  MotifButton,
  MotifDatePicker,
  MotifIcon,
  MotifOption,
  MotifProgressLoader,
  MotifSelect,
  MotifTabControl,
  MotifTabNavigation,
  MotifErrorMessage,
  MotifTruncate,
  MotifTooltip,
  MotifToast,
  MotifDropdown,
  MotifDropdownItem,
  MotifChip,
} from "@ey-xd/motif-react";
import React, {
  ReactNode,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import "./OrderPipeline.scss";
import {
  formatCurrency,
  getFormattedDate,
  getFormattedTime,
  getTotalOrderAmount,
  getTotalRecoveriesAmount,
} from "./helper";
import OrdersEstimateTable from "./OrdersEstimateTable";
import CancelledOrdersTable from "./CancelledOrdersTable";
import OrdersRecoveryTable from "./OrdersRecoveryTable";
import AutoTransactTable from "./AutoTransactTable";
import ApprovalsTable from "./ApprovalsTable";
import {
  cancelOrder,
  fetchOrderPipelineListData,
  resetOrderPipelineListState,
  approveOrderSku,
  rejectOrderSku,
  fetchRecoveriesListData,
  fetchOrderExportData,
} from "../../store/slices/OrderPipelineSlice";
import {
  ESTIMATE,
  ORDER,
  CANCELLED_ORDERS,
  APPROVALS,
  RECOVERIES,
  TOTAL_BILLED,
  RETURNS,
  TRANSACTIONS,
  TOTAL_BILLED_TOOLTIP,
  TRANSACTION_ID_TOOLTIP_TITLE,
  EMOJI_ERROR_MESSAGE,
  SEARCH_TIMER,
  IN_APPROVAL_STATUS,
} from "../../Constant";
import CustomPagination from "../CustomPagination/CustomPagination";
import productListEmptyImg from "../../assets/images/empty_product_list_default.svg";
import ErrorOrderPage from "../ErrorOrderPage/ErrorOrderPage";
import OrdersTable from "./OrdersTable";
import ApprovalStatusPopover from "./ApprovalStatusPopover";
import {
  deployementApproverProvStatus,
  deploymentApproverObject,
} from "../../store/slices/DeploymentApproverStatusSlice";
import { Pagination, OrderData, ReturnOrderData } from "./types";
import {
  containsEmoji,
  isAbortError,
  truncateString,
  formatMetricByQuantity,
} from "../../utils/common";
import RejectModal from "./ApprovalsTable/RejectModal/RejectModal";
import ApproveModal from "./ApprovalsTable/ApproveModal/ApproveModal";
import SearchInput from "../SearchInput/SearchInput";
import CancelModal from "./OrdersTable/CancelModal/CancelModal";
import ReturnOrderModal from "./OrdersTable/ReturnOrderModal/ReturnOrderModal";
import { EntityData } from "../../store/models/userModel";
import { getUserFrontendPermissions } from "../../store/slices/UserPermissionsSlice";
import ReturnOrdersTable from "./ReturnTable/ReturnOrdersTable";
import { Toast } from "../Toast/Toast";
import MultiSelect from "../MultiSelect/MultiSelect";
import SkuProvisionModal from "./OrdersTable/SkuProvisionModal";
import {
  convertDateStringtoDate,
  formatToLocalYYYYMMDD,
  formatToUTCYYYYMMDD,
} from "../../utils/dateFunction";
import { isEmpty } from "../../utils/Validator";
import {
  fixedCostInfo,
  skuIDInfo,
  variableCostInfo,
} from "../../utils/skuTable";
import {
  approvedUnitUsedInfo,
  OrderNameInfo,
  requestedDateInfo,
  returnIdInfo,
  returnStatusInfo,
  returnUnitUsedInfo,
  unitUsedInfo,
} from "../../utils/returnTable";
import EmailNotification from "./../EmailNotification";

type EmailNotificationState = {
  show: boolean;
  message: string;
  supportingText: string | React.ReactNode;
  type: "error" | "success" | "info" | "warning";
  actionRedirectUrl: string;
  actionRedirectLabel: string;
};

interface OrderPipelineProps {
  setSelectedTabHome: (key: number) => void;
  defaultTab: number;
}

interface Order {
  OrderParentId: string;
  Description: string;
  CreatedDtm: string;
  StatusCd: string;
}
interface CancelRequestObj {
  Action: string;
  OrderSkuId: number;
}

const OrderPipeline: React.FC<OrderPipelineProps> = ({
  setSelectedTabHome,
  defaultTab,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const [isEstimateLoading, setIsEstimateLoading] = useState(false);
  const [isRecoveriesLoading, setIsRecoveriesLoading] = useState(false);
  const [isRecoveriesDetailsLoading, setIsRecoveriesDetailsLoading] =
    useState(false);
  const [isRecoveriesError, setIsRecoveriesError] = useState(false);
  const [isRecoveriesDetailsError, setIsRecoveriesDetailsError] =
    useState(false);
  const [totalRecoveriesPages, setTotalRecoveriesPages] = useState<number>(0);
  const [totalRecoveriesRecords, setTotalRecoveriesRecords] =
    useState<number>(0);
  const [totalBilledInRecoveries, setTotalBilledInRecoveries] =
    useState<number>(0);
  const [showRecoveriesPagination, setShowRecoveriesPagination] =
    useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isEstimateError, setIsEstimateError] = useState(false);
  const [ordersEstimate, setOrdersEstimate] = useState<any>([]);
  const [ordersRecoveries, setOrdersRecoveries] = useState<any>([]);
  const [recoveryDetailsErrorMap, setRecoveryDetailsErrorMap] = useState<
    Record<string, string>
  >({});
  const [showEstimatePagination, setShowEstimatePagination] = useState(false);
  const [totalEstimatePages, setTotalEstimatePages] = useState<number>(0);
  const [totalEstimateRecords, setTotalEstimateRecords] = useState<number>(0);
  const [rowDates, setRowDates] = useState<Record<string, Date | null>>({});
  const [toastMessage, setToastMessage] = useState<string>("");
  const [toastSuccessMessage, setToastSuccessMessage] = useState<string>("");
  const [validationError, setValidationError] = useState<
    Record<string, string>
  >({});
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [paginationEstimateObj, setPaginationEstimateObj] = useState<any>({
    currentPage: 1,
    pageSize: 10,
  });

  const [paginationRecoveriesObj, setPaginationRecoveriesObj] = useState<any>({
    currentPage: 1,
    pageSize: 10,
    searchText: "",
  });

  const [isToggleOpen, setIsToggleOpen] = useState<boolean>(false);
  const [isOrdersLoading, setIsOrdersLoading] = useState(false);
  const [isOrdersError, setIsOrdersError] = useState(false);
  const [orders, setOrders] = useState<Order[]>([]);
  const [showOrdersPagination, setShowOrdersPagination] = useState(false);
  const [totalOrdersPages, setTotalOrdersPages] = useState<number>(0);
  const [totalOrdersRecords, setTotalOrdersRecords] = useState<number>(0);
  const [isClearEstimateBtnDisabled, setIsClearEstimateBtnDisabled] =
    useState(true);
  const [isClearOrderBtnDisabled, setIsClearOrderBtnDisabled] = useState(true);
  const [isClearApprovalBtnDisabled, setIsClearApprovalBtnDisabled] =
    useState(true);
  const [isClearCancelledBtnDisabled, setIsClearCancelledBtnDisabled] =
    useState(true);
  const [isClearRecoveriesBtnDisabled, setIsClearRecoveriesBtnDisabled] =
    useState(true);
  const [isClearReturnBtnDisabled, setIsClearReturnBtnDisabled] =
    useState(true);
  const [searchValidationError, setSearchValidationError] =
    useState<string>("");
  // const [isClearAutoTransactBtnDisabled, setIsClearAutoTransactBtnDisabled] =
  //   useState(true);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [paginationOrdersObj, setPaginationOrdersObj] = useState<any>({
    currentPage: 1,
    pageSize: 10,
    searchText: "",
  });
  const [selectedProvStatusInOrder, setSelectedProvStatusInOrder] = useState<
    string[]
  >([]);
  const [totalApprovalsPages, setTotalApprovalsPages] = useState<number>(0);
  const [totalApprovalsRecords, setTotalApprovalsRecords] = useState<number>(0);
  const [paginationForApprovals, setPaginationForApproval] =
    useState<Pagination>({
      currentPage: 1,
      pageSize: 10,
      searchText: "",
    });
  const [approvalList, setApprovalList] = useState<OrderData[]>([]);
  const [isApprovalListApiError, setIsApprovalListApiError] = useState(false);
  const [showApprovalPagination, setShowApprovalPagination] = useState(false);
  const [showRejectSkuModal, setShowRejectSkuModal] = useState<boolean>(false);
  const [rejectReasonApiError, setRejectReasonApiError] = useState("");
  const [orderStatus, setOrderStatus] = useState("all");
  const [statusCol, setStatusCol] = useState("ordersku_submitted");
  const [hasUserSelectedStatus, setHasUserSelectedStatus] = useState(false);
  const [billingType, setBillingType] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [showApproveSkuModal, setShowApproveSkuModal] =
    useState<boolean>(false);
  //Cancellation Tab
  const [isCancelledOrdersLoading, setIsCancelledOrdersLoading] =
    useState(false);
  const [isCancelledOrdersError, setIsCancelledOrdersError] = useState(false);
  const [cancelledOrders, setCancelledOrders] = useState<Order[]>([]);
  const [showCancelledOrdersPagination, setShowCancelledOrdersPagination] =
    useState(false);
  const [totalCancelledOrdersPages, setTotalCancelledOrdersPages] =
    useState<number>(0);
  const [totalCancelledOrdersRecords, setTotalCancelledOrdersRecords] =
    useState<number>(0);
  const [paginationCancelledOrdersObj, setPaginationCancelledOrdersObj] =
    useState<any>({
      currentPage: 1,
      pageSize: 10,
      searchText: "",
    });

  //Return Tab
  const [isReturnOrdersLoading, setIsReturnOrdersLoading] = useState(false);
  const [isReturnOrdersError, setIsReturnOrdersError] = useState(false);
  const [showReturnOrdersPagination, setShowReturnOrdersPagination] =
    useState(false);
  const [returnList, setReturnList] = useState<OrderData[]>([]);
  const [totalReturnPages, setTotalReturnPages] = useState<number>(0);
  const [totalReturnRecords, setTotalReturnRecords] = useState<number>(0);
  const [paginationForReturn, setPaginationForReturn] = useState<Pagination>({
    currentPage: 1,
    pageSize: 10,
    searchText: "",
  });
  const [selectedReturnStatus, setSelectedReturnStatus] = useState<string[]>(
    [],
  );
  const [selectedReturnType, setSelectedReturnType] = useState<string[]>([]);
  const [selectedReturnRequestedDate, setSelectedReturnRequestedDate] =
    useState<string>("All");

  //Auto Transactions Table
  const [ordersAutoTransact, setOrdersAutoTransact] = useState<any[]>([]);
  const [isAutoTransactLoading, setIsAutoTransactLoading] = useState(false);
  const [isAutoTransactError, setIsAutoTransactError] = useState(false);
  const [showAutoTransactPagination, setShowAutoTransactPagination] =
    useState(false);
  const [totalAutoTransactPages, setTotalAutoTransactPages] =
    useState<number>(0);
  const [totalAutoTransactRecords, setTotalAutoTransactRecords] =
    useState<number>(0);
  const [paginationAutoTransactObj, setPaginationAutoTransactObj] =
    useState<any>({
      currentPage: 1,
      pageSize: 10,
      searchText: "",
    });

  const [selectedSkuName, setSelectedSkuName] = useState("");
  const [selectedProductName, setSelectedProductName] = useState("");
  const [selectedTransactionStatus, setSelectedTransactionStatus] =
    useState("");
  const [totalBilledAutoTransact, setTotalBilledAutoTransact] =
    useState<number>(0);

  const [selectedTab, setSelectedTab] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  //Defining the state variable for the selecte SKU ID
  const [selectedSku, setSelectedSku] = useState<string>("");
  const [selectedOrderSkuId, setSelectedOrderSkuId] = useState<number>(0);
  const [selectedRole, setSelectedRole] = useState<string>("");
  const [selectedOrderParentId, setSelectedOrderParentId] = useState<number>(0);

  const [showCancelOrderModal, setShowCancelOrderModal] =
    useState<boolean>(false);
  const [selectedCancelOrder, setSelectedCancelOrder] =
    useState<CancelRequestObj | null>(null);
  const [isCancelOrderLoading, setIsCancelOrderLoading] = useState(false);
  const [selectedSkuData, setSelectedSkuData] = useState<OrderData>();
  const [toastSuccess, setToastSuccess] = useState(false);
  const [showReturnOrderModal, setShowReturnOrderModal] =
    useState<boolean>(false);
  const [exportErrorMessage, setExportErrorMessage] = useState("");
  const [exportSuccessMessage, setExportSuccessMessage] = useState("");
  const [isCSVLoading, setIsCSVLoading] = useState(false);
  const [showProvisioningModal, setShowProvisioningModal] = useState(false);
  const [tempProvisionStatus, setTempProvisionStatus] = useState<string>("");

  const [emailNotification, setEmailNotification] =
    useState<EmailNotificationState | null>(null);

  const abortControllerRef = useRef<AbortController | null>(null);

  const provStatusOptionsInOrders = [
    { value: "partner_approval", label: "Partner Approval" },
    { value: "submitted", label: "Not Started" },
    { value: "pending", label: "In Progress" },
    { value: "active", label: "Completed" },
  ];
  const returnStatusOptions = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];
  const returnTypeOptions = [
    { value: "Partial Refund", label: "Partial Refund" },
    { value: "Full Refund", label: "Full Refund" },
    { value: "TBD", label: "TBD" },
    { value: "Rejected", label: "Rejected" },
  ];
  const returnRequestedDateOptions = [
    { value: "All", label: "All" },
    { value: "This Month", label: "This Month" },
    { value: "Last 30 Days", label: "Last 30 Days" },
    { value: "Year To Date", label: "Year To Date (YTD)" },
  ];

  const scrollWrapperRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);
  const thumbRef = useRef<HTMLDivElement>(null);
  // below useRef code should be removed when we have apply filter button and we can call API on button click instead of on change of filter value
  const ordersFilterTimerRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const returnsFilterTimerRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const [trackWidth, setTrackWidth] = useState(0);
  const [isSticky, setIsSticky] = useState(false);

  const userEntityData: EntityData[] = useSelector(
    (state: RootState) => state.UserFrontendProfileSlice.userEntityData,
  );

  const orderPipelineQueryParamsRef = useRef<{
    OrderId?: string;
    SkuId?: string;
    ReturnId?: string;
    Source?: string;
    Role?: string;
    OrderSkuId?: number;
  } | null>(null);

  const getOrderPipelineQueryParams = () => {
    if (orderPipelineQueryParamsRef.current) {
      return orderPipelineQueryParamsRef.current;
    }
    const currentQueryParams = new URLSearchParams(window.location.search);
    const orderId = currentQueryParams.get("OrderId");
    const skuId = currentQueryParams.get("SkuId");
    const returnId = currentQueryParams.get("ReturnId");
    const source = currentQueryParams.get("Source");
    const role = currentQueryParams.get("Role");
    const orderSkuId = currentQueryParams.get("OrderSkuId")
      ? Number(currentQueryParams.get("OrderSkuId"))
      : undefined;
    orderPipelineQueryParamsRef.current =
      orderId && skuId
        ? source && role && orderSkuId
          ? {
              OrderId: orderId,
              SkuId: skuId,
              Source: source,
              Role: role,
              OrderSkuId: orderSkuId,
            }
          : {
              OrderId: orderId,
              SkuId: skuId,
            }
        : returnId
          ? source && role && orderSkuId
            ? {
                ReturnId: returnId,
                Source: source,
                Role: role,
                OrderSkuId: orderSkuId,
              }
            : { ReturnId: returnId }
          : {};
    return orderPipelineQueryParamsRef.current;
  };

  const getSearchWithoutOrderPipelineQueryParams = () => {
    const currentQueryParams = new URLSearchParams(location.search);
    currentQueryParams.delete("OrderId");
    currentQueryParams.delete("SkuId");
    currentQueryParams.delete("ReturnId");
    currentQueryParams.delete("Source");
    currentQueryParams.delete("Role");
    currentQueryParams.delete("OrderSkuId");
    return currentQueryParams.toString()
      ? `?${currentQueryParams.toString()}`
      : "";
  };

  const removeOrderPipelineQueryParams = () => {
    orderPipelineQueryParamsRef.current = {};
    setEmailNotification(null);
    const search = getSearchWithoutOrderPipelineQueryParams();
    if (search === location.search) {
      return;
    }
    navigate(
      {
        pathname: location.pathname,
        search,
      },
      { replace: true },
    );
  };

  useEffect(() => {
    const currentQueryParams = new URLSearchParams(location.search);
    if (
      (currentQueryParams.has("OrderId") && currentQueryParams.has("SkuId")) ||
      currentQueryParams.has("ReturnId")
    ) {
      orderPipelineQueryParamsRef.current = null;
    }
  }, [location.search]);

  useEffect(() => {
    dispatch(getUserFrontendPermissions());
  }, []);

  // below useRef code should be removed when we have apply filter button and we can call API on button click instead of on change of filter value
  useEffect(() => {
    return () => {
      if (ordersFilterTimerRef.current) {
        clearTimeout(ordersFilterTimerRef.current);
      }

      if (returnsFilterTimerRef.current) {
        clearTimeout(returnsFilterTimerRef.current);
      }
    };
  }, []);

  const renderHeaderWithTooltip = (
    label: string,
    tooltipContent: ReactNode,
  ) => {
    return (
      <div className="header-with-tooltip">
        <div>{label}</div>
        <MotifTooltip
          contentClassName="tooltip-content return-modal-tooltip-content"
          allowHover
          hideArrow
          trigger={
            <div className="tooltip-icon-wrapper">
              <MotifIcon
                iconFunction={IconoirHelpCircle}
                size="16"
                fill="#AFAEBA"
              />
            </div>
          }
        >
          <>{tooltipContent}</>
        </MotifTooltip>
      </div>
    );
  };

  const filteredEntityIds = userEntityData
    .filter(
      (item) =>
        item.RoleCd === "sku_deploymentapprover" && item.EntityType === "sku",
    )
    .map((item) => item.EntityId);

  const disableSku = (order: OrderData) => {
    return filteredEntityIds.includes(order.SkuId);
  };

  const clearFilter = () => {
    removeOrderPipelineQueryParams();
    if (ordersFilterTimerRef.current) {
      clearTimeout(ordersFilterTimerRef.current);
      ordersFilterTimerRef.current = null;
    }

    if (returnsFilterTimerRef.current) {
      clearTimeout(returnsFilterTimerRef.current);
      returnsFilterTimerRef.current = null;
    }

    if (selectedTab === 1) {
      setSelectedProvStatusInOrder([]);
      setDateRange([null, null]);
      setIsClearOrderBtnDisabled(true);
      setPaginationOrdersObj((prev: any) => ({
        ...prev,
        OrderStatus: "all",
        ProvisioningStatus: [],
        currentPage: 1,
      }));
    } else if (selectedTab === 2) {
      setDateRange([null, null]);
      setIsClearApprovalBtnDisabled(true);
      setPaginationForApproval((prev) => ({
        ...prev,
        StartDate: formatToLocalYYYYMMDD(null),
        EndDate: formatToLocalYYYYMMDD(null),
        currentPage: 1,
      }));
    } else if (selectedTab === 3) {
      setDateRange([null, null]);
      setIsClearCancelledBtnDisabled(true);
      setPaginationCancelledOrdersObj((prev: any) => ({
        ...prev,
        StartDate: formatToLocalYYYYMMDD(null),
        EndDate: formatToLocalYYYYMMDD(null),
        currentPage: 1,
      }));
    } else if (selectedTab === 5) {
      setBillingType("");
      setTransactionDate("");
      setDateRange([null, null]);
      setIsClearRecoveriesBtnDisabled(true);
      setPaginationRecoveriesObj((prev: any) => ({
        ...prev,
        BillingType: "",
        TransactionDateFilter: "",
        // StartDate: formatToLocalYYYYMMDD(null),
        // EndDate: formatToLocalYYYYMMDD(null),
        currentPage: 1,
      }));
      // } else if (selectedTab === 6) {
      //   setSelectedSkuName("");
      //   setSelectedProductName("");
      //   setSelectedTransactionStatus("");
      //   setDateRange([null, null]);
      //   setIsClearAutoTransactBtnDisabled(true);
      //   setPaginationAutoTransactObj((prev: any) => ({
      //     ...prev,
      //     SkuName: "",
      //     ProductName: "",
      //     TransactionStatus: "",
      //     StartDate: formatToLocalYYYYMMDD(null),
      //     EndDate: formatToLocalYYYYMMDD(null),
      //     currentPage: 1,
      //   }));
    } else if (selectedTab === 4) {
      setSelectedReturnStatus([]);
      setSelectedReturnType([]);
      setSelectedReturnRequestedDate("All");
      setIsClearReturnBtnDisabled(true);
      setPaginationForReturn((prev: any) => ({
        ...prev,
        Status: [],
        Type: [],
        RequestedDate: "All",
        currentPage: 1,
      }));
    } else {
      // Default selected tab is zero
      setOrderStatus("all");
      setDateRange([null, null]);
      setIsClearEstimateBtnDisabled(true);
      setPaginationEstimateObj((prev: any) => ({
        ...prev,
        Status: "all",
        currentPage: 1,
      }));
    }
  };

  const handleDateChange = (range: any) => {
    removeOrderPipelineQueryParams();
    setDateRange(range);
    setIsClearEstimateBtnDisabled(false);
    setIsClearOrderBtnDisabled(false);
    setIsClearApprovalBtnDisabled(false);
    setIsClearCancelledBtnDisabled(false);
    setIsClearRecoveriesBtnDisabled(false);
    // setIsClearAutoTransactBtnDisabled(false);

    setPaginationEstimateObj((prev: any) => ({
      ...prev,
      StartDate: formatToLocalYYYYMMDD(startDate),
      EndDate: formatToLocalYYYYMMDD(endDate),
      currentPage: 1,
    }));
    setPaginationForApproval((prev) => ({
      ...prev,
      StartDate: formatToLocalYYYYMMDD(startDate),
      EndDate: formatToLocalYYYYMMDD(endDate),
      currentPage: 1,
    }));
    setPaginationCancelledOrdersObj((prev: any) => ({
      ...prev,
      StartDate: formatToLocalYYYYMMDD(startDate),
      EndDate: formatToLocalYYYYMMDD(endDate),
      currentPage: 1,
    }));
    // setPaginationRecoveriesObj((prev: any) => ({
    //   ...prev,
    //    StartDate: formatToLocalYYYYMMDD(startDate),
    //    EndDate: formatToLocalYYYYMMDD(endDate),
    //   currentPage: 1,
    // }));
    setPaginationOrdersObj((prev: any) => ({
      ...prev,
      StartDate: formatToLocalYYYYMMDD(startDate),
      EndDate: formatToLocalYYYYMMDD(endDate),
      currentPage: 1,
    }));
    setPaginationAutoTransactObj((prev: any) => ({
      ...prev,
      StartDate: formatToLocalYYYYMMDD(startDate),
      EndDate: formatToLocalYYYYMMDD(endDate),
      currentPage: 1,
    }));
  };

  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (toastSuccess || toastMessage) {
      const timer = setTimeout(() => {
        if (toastSuccess) setToastSuccess(false);
        if (toastMessage) setToastMessage("");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [toastSuccess, toastMessage]);

  // This function to validate search and prevent API call if emoji exists
  const shouldSkipApiCall = (searchText: string): boolean => {
    const hasEmoji = containsEmoji(searchText);
    if (hasEmoji) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, SEARCH_TIMER);

    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    if (shouldSkipApiCall(debouncedSearchValue)) {
      return;
    }
    abortControllerRef &&
      abortControllerRef.current &&
      abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    if (selectedTab === 0) {
      setIsEstimateError(false);
      resetOrderPipelineListState();
      setIsEstimateLoading(true);
      setTotalEstimatePages(0);
      setTotalEstimateRecords(0);
      setOrdersEstimate([]);
      dispatch(
        fetchOrderPipelineListData({
          Action: "retriveAllEstimatedOrders",
          Page: paginationEstimateObj.currentPage,
          Record: paginationEstimateObj.pageSize,
          ...(debouncedSearchValue && { SearchText: debouncedSearchValue }),
          Status: orderStatus,
          StartDate: formatToLocalYYYYMMDD(startDate),
          EndDate: formatToLocalYYYYMMDD(endDate),
          signal: signal,
        }),
      )
        .unwrap()
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((payload: any) => {
          if (payload?.Data == undefined) {
            return;
          }
          setOrdersEstimate(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            payload.Data.Result.map((order: any) => ({
              ...order,
              isSKUExpanded: false,
              isOrderExpanded: false,
            })) || [],
          );
          setTotalEstimatePages(payload.Data.TotalPages || 0);
          setTotalEstimateRecords(payload.Data.TotalRecord || 0);
          setIsEstimateLoading(false);
        })
        .catch((error: any) => {
          if (isAbortError(error) || (error as any)?.code === "ERR_CANCELED") {
            // Handle abort
            return;
          }
          setIsEstimateError(true);
          setIsEstimateLoading(false);
        });
    }
    if (selectedTab === 1) {
      loadOrderTab(signal);
      setExportSuccessMessage("");
      setExportErrorMessage("");
      setIsCSVLoading(false);
    }
    if (selectedTab === 2) {
      fetchApprovalList();
    }
    if (selectedTab === 3) {
      setIsCancelledOrdersError(false);
      resetOrderPipelineListState();
      setIsCancelledOrdersLoading(true);
      setTotalCancelledOrdersPages(0);
      setTotalCancelledOrdersRecords(0);
      setCancelledOrders([]);
      dispatch(
        fetchOrderPipelineListData({
          Action: "retriveAllCancelledOrders",
          Status: "cancelled",
          Page: paginationCancelledOrdersObj.currentPage,
          Record: paginationCancelledOrdersObj.pageSize,
          ...(debouncedSearchValue && { SearchText: debouncedSearchValue }),
          StartDate: formatToLocalYYYYMMDD(startDate),
          EndDate: formatToLocalYYYYMMDD(endDate),
          signal: signal,
        }),
      )
        .unwrap()
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((payload: any) => {
          if (payload?.Data == undefined) {
            return;
          }
          setCancelledOrders(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            payload.Data.Result.map((order: any) => ({
              ...order,
              isSKUExpanded: false,
              isOrderExpanded: false,
            })) || [],
          );
          setTotalCancelledOrdersPages(payload.Data.TotalPages || 0);
          setTotalCancelledOrdersRecords(payload.Data.TotalRecord || 0);
          setIsCancelledOrdersLoading(false);
        })
        .catch((error: any) => {
          if (isAbortError(error) || (error as any)?.code === "ERR_CANCELED") {
            // Handle abort
            return;
          }
          setIsCancelledOrdersError(true);
          setIsCancelledOrdersLoading(false);
        });
    }
    if (selectedTab === 4) {
      fetchReturnList();
    }
    if (selectedTab === 5) {
      fetchRecoveriesList();
    }
    if (selectedTab === 6) {
      fetchAutoTransactList();
    }
    if (isToggleOpen) {
      handleClearBtn();
    }
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    paginationOrdersObj,
    paginationEstimateObj,
    paginationForApprovals,
    paginationCancelledOrdersObj,
    paginationForReturn,
    paginationRecoveriesObj,
    paginationAutoTransactObj,
    selectedTab,
    debouncedSearchValue,
  ]);

  const getFormattedTransactionStatus = (status: string, reason: string) => {
    switch (status) {
      case "Approved":
        return (
          <div className="return-approved">
            <div>{status}</div>
            <div>
              <MotifIcon iconFunction={IconoirCheck} />
            </div>
          </div>
        );
      case "Rejected":
        return (
          <>
            <div className="return-rejected">
              <MotifTooltip
                contentClassName="tooltip-content"
                hideArrow={true}
                trigger={<div>{status}</div>}
              >
                <>
                  Rejection Reason
                  <div
                    className="motif-caption-default-light returnsRejectToolTip"
                    style={{
                      marginTop: "6px",
                    }}
                  >
                    {reason}
                  </div>
                </>
              </MotifTooltip>
              <div>
                <MotifIcon iconFunction={IconoirXmark} />
              </div>
            </div>
          </>
        );
      case "Pending":
        return (
          <div className="return-pending">
            <div>{IN_APPROVAL_STATUS}</div>
            <div>
              <MotifIcon iconFunction={IconoirTimer} />
            </div>
          </div>
        );
      default:
        return status;
    }
  };

  const statusLegend = () => (
    <div className="approval-status-legend">
      <div className="status-wrapper">
        <MotifIcon
          className="status-badge approved-icon"
          iconFunction={selectedTab === 1 ? IconoirCheckCircle : IconoirCheck}
          size="17"
        />
        <div className="status-text">Approved</div>
      </div>
      <div className="status-wrapper">
        <div className="status-badge rejected-icon">
          <MotifIcon
            size="17"
            iconFunction={selectedTab === 1 ? IconoirInfoCircle : IconoirXmark}
          />
        </div>
        <div className="status-text">Rejected</div>
      </div>
      <div className="status-wrapper">
        <div className="status-badge pending-icon">
          <MotifIcon size="17" iconFunction={IconoirTimer} />
        </div>
        <div className="status-text">Pending Approval</div>
      </div>
    </div>
  );

  useEffect(() => {
    setSelectedTab(defaultTab);
    handleSearch("", false);
    setSearchValue("");
    setSearchValidationError("");
    setDebouncedSearchValue("");
  }, [defaultTab]);

  const onTabChange = (tabName: string) => {
    if (ordersFilterTimerRef.current) {
      clearTimeout(ordersFilterTimerRef.current);
      ordersFilterTimerRef.current = null;
    }

    if (returnsFilterTimerRef.current) {
      clearTimeout(returnsFilterTimerRef.current);
      returnsFilterTimerRef.current = null;
    }
    setDateRange([null, null]);
    setSelectedProvStatusInOrder([]);
    setBillingType("");
    setOrderStatus("all");
    setTransactionDate("");
    setSelectedSkuName("");
    setSelectedProductName("");
    setSelectedTransactionStatus("");
    setSelectedReturnStatus([]);
    setSelectedReturnType([]);
    setSelectedReturnRequestedDate("All");
    setIsToggleOpen(false);
    handleSearch("", false);
    setSearchValue("");
    setSearchValidationError("");
    setIsClearEstimateBtnDisabled(true);
    setIsClearOrderBtnDisabled(true);
    setIsClearApprovalBtnDisabled(true);
    setIsClearCancelledBtnDisabled(true);
    setIsClearRecoveriesBtnDisabled(true);
    setIsClearReturnBtnDisabled(true);
    setEmailNotification(null);
    orderPipelineQueryParamsRef.current = {};
    navigate({
      pathname: `/order-pipeline/${tabName}`,
      search: getSearchWithoutOrderPipelineQueryParams(),
    });
  };

  const handleOrderReturnSuccess = () => {
    onTabChange("returns");
    setPaginationForReturn({
      currentPage: 1,
      pageSize: 10,
      searchText: "",
    });
    setToastSuccess(true);
    setToastSuccessMessage("Return has been submitted successfully.");
  };

  const handleSearch = (value: string, shouldRemoveQueryParams = true) => {
    if (shouldRemoveQueryParams) {
      removeOrderPipelineQueryParams();
    }
    setSearchValue(value);
    setPaginationEstimateObj((prev: any) => ({
      ...prev,
      currentPage: 1,
      searchText: value,
    }));
    setPaginationOrdersObj((prev: any) => ({
      ...prev,
      searchText: value,
      currentPage: 1,
    }));
    setPaginationForApproval((prev) => ({
      ...prev,
      searchText: value,
      currentPage: 1,
    }));
    setPaginationCancelledOrdersObj((prev: any) => ({
      ...prev,
      searchText: value,
      currentPage: 1,
    }));
    setPaginationRecoveriesObj((prev: any) => ({
      ...prev,
      searchText: value,
      currentPage: 1,
    }));
    setPaginationForReturn((prev: any) => ({
      ...prev,
      searchText: value,
      currentPage: 1,
    }));
    setPaginationAutoTransactObj((prev: any) => ({
      ...prev,
      searchText: value,
      currentPage: 1,
    }));
  };

  const resetPagination = () => {
    setPaginationEstimateObj((prev: any) => ({
      ...prev,
      currentPage: 1,
    }));
    setPaginationOrdersObj((prev: any) => ({
      ...prev,
      currentPage: 1,
    }));
    setPaginationForApproval((prev) => ({
      ...prev,
      currentPage: 1,
    }));
    setPaginationCancelledOrdersObj((prev: any) => ({
      ...prev,
      currentPage: 1,
    }));
    setPaginationRecoveriesObj((prev: any) => ({
      ...prev,
      currentPage: 1,
    }));
    setPaginationForReturn((prev: any) => ({
      ...prev,
      currentPage: 1,
    }));
    setPaginationAutoTransactObj((prev: any) => ({
      ...prev,
      currentPage: 1,
    }));
  };

  const loadOrderTab = (signal?: AbortSignal) => {
    setEmailNotification(null);
    setIsOrdersError(false);
    resetOrderPipelineListState();
    setIsOrdersLoading(true);
    setTotalOrdersPages(0);
    setTotalOrdersRecords(0);
    setOrders([]);
    setValidationError({});
    dispatch(
      fetchOrderPipelineListData({
        Action: "retrieveAllSkuOrder",
        Status: "Active",
        Page: paginationOrdersObj.currentPage,
        Record: paginationOrdersObj.pageSize,
        ...(debouncedSearchValue && { SearchText: debouncedSearchValue }),
        StartDate: formatToLocalYYYYMMDD(startDate),
        EndDate: formatToLocalYYYYMMDD(endDate),
        ProvisioningStatus: selectedProvStatusInOrder.length
          ? selectedProvStatusInOrder
          : ["all"],
        OrderStatus: "",
        ...getOrderPipelineQueryParams(),
        signal,
      }),
    )
      .unwrap()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((payload: any) => {
        const ctaResponse = payload?.CTAResponse;
        if (ctaResponse) {
          setEmailNotification({
            show: true,
            message:
              ctaResponse.ApprovalStatus.trim().toLowerCase() === "cancelled"
                ? `SKU order already ${ctaResponse.ApprovalStatus.toLowerCase()}`
                : `Request is already ${ctaResponse.ApprovalStatus.trim().toLowerCase()}`,
            supportingText:
              ctaResponse.ApprovalStatus.trim().toLowerCase() ===
              "cancelled" ? (
                <span>
                  The SKU{" "}
                  <b>
                    {ctaResponse.SkuName} - {ctaResponse.SkuId}
                  </b>{" "}
                  from order{" "}
                  <b>
                    {ctaResponse.OrderName} - {ctaResponse.OrderId}
                  </b>{" "}
                  was already {ctaResponse.ApprovalStatus.trim().toLowerCase()}{" "}
                  by <b>{ctaResponse.ApproverFullName}</b>.
                </span>
              ) : (
                <span>
                  This request is already been{" "}
                  {ctaResponse.ApprovalStatus.trim().toLowerCase()} by{" "}
                  <b>{ctaResponse.ApproverFullName}</b> on{" "}
                  <b>{ctaResponse.Time}</b>. No further action required.
                </span>
              ),
            type: "info",
            actionRedirectUrl: "",
            actionRedirectLabel: "",
          });
        } else {
          setEmailNotification(null);
        }
        if (payload?.Data == undefined) {
          return;
        }
        setOrders(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          payload.Data.Result.map((order: any) => ({
            ...order,
            isSKUExpanded: false,
            isOrderExpanded: false,
          })) || [],
        );
        setTotalOrdersPages(payload.Data.TotalPages || 0);
        setTotalOrdersRecords(payload.Data.TotalRecord || 0);
        setIsOrdersLoading(false);
      })
      .catch((error) => {
        if (isAbortError(error) || error?.code === "ERR_CANCELED") {
          // Handle abort
          return;
        }
        setIsOrdersError(true);
        setIsOrdersLoading(false);
      });
  };

  // approval tab data load function
  const fetchApprovalList = () => {
    abortControllerRef &&
      abortControllerRef.current &&
      abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    setIsApprovalListApiError(false);
    resetOrderPipelineListState();
    setIsLoading(true);
    setTotalOrdersPages(0);
    setTotalApprovalsRecords(0);
    setApprovalList([]);
    dispatch(
      fetchOrderPipelineListData({
        Action: "retriveallapprovalsdorders",
        Status: "approvals",
        Page: paginationForApprovals.currentPage,
        Record: paginationForApprovals.pageSize,
        OrderStatus: "",
        ...(debouncedSearchValue && { SearchText: debouncedSearchValue }),
        StartDate: formatToLocalYYYYMMDD(startDate),
        EndDate: formatToLocalYYYYMMDD(endDate),
        // ...getApprovalQueryParams(),
        ...getOrderPipelineQueryParams(),
        signal: signal,
      }),
    )
      .unwrap()
      .then((payload: any) => {
        if (payload?.Data == undefined) {
          return;
        }
        if (payload.CTAResponse) {
          setEmailNotification({
            show: true,
            message: `SKU order already ${payload.CTAResponse.ApprovalStatus.toLowerCase()}`,
            supportingText: (
              <span>
                The SKU{" "}
                <b>
                  {payload.CTAResponse.SkuName} - {payload.CTAResponse.SkuId}
                </b>{" "}
                from order{" "}
                <b>
                  {payload.CTAResponse.OrderName} -{" "}
                  {payload.CTAResponse.OrderId}
                </b>{" "}
                was already {payload.CTAResponse.ApprovalStatus.toLowerCase()}{" "}
                by <b>{payload.CTAResponse.ApproverFullName}</b>.
              </span>
            ),
            type: "info",
            actionRedirectUrl: "/ct/bmo",
            actionRedirectLabel: "Review pending approvals",
          });
        }
        if (!payload.CTAResponse) {
          setEmailNotification(null);
        }
        setApprovalList(
          payload.Data.Result.map((order: any) => ({
            ...order,
            isSKUExpanded: false,
            isOrderExpanded: false,
          })) || [],
        );
        setTotalApprovalsPages(payload.Data.TotalPages || 0);
        setTotalApprovalsRecords(payload.Data.TotalRecord || 0);
        setIsLoading(false);
      })
      .catch((error: any) => {
        if (isAbortError(error) || (error as any)?.code === "ERR_CANCELED") {
          // Handle abort
          return;
        }
        setIsApprovalListApiError(true);
        setIsLoading(false);
      });
  };
  const fetchReturnList = () => {
    setIsReturnOrdersError(false);
    resetOrderPipelineListState();
    setIsReturnOrdersLoading(true);
    setTotalReturnRecords(0);
    setTotalReturnPages(0);
    setReturnList([]);
    abortControllerRef &&
      abortControllerRef.current &&
      abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    dispatch(
      fetchOrderPipelineListData({
        Action: "retriveallreturnorders",
        Status: selectedReturnStatus,
        Page: paginationForReturn.currentPage,
        Record: paginationForReturn.pageSize,
        Type: selectedReturnType,
        RequestedDate: selectedReturnRequestedDate,
        ...(debouncedSearchValue && { SearchText: debouncedSearchValue }),
        ...getOrderPipelineQueryParams(),
        signal: signal,
      }),
    )
      .unwrap()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((payload: any) => {
        if (payload?.Data == undefined) {
          return;
        }
        if (payload.CTAResponse) {
          setEmailNotification({
            show: true,
            message: `SKU order already ${payload.CTAResponse.ApprovalStatus.toLowerCase()}`,
            supportingText: (
              <span>
                The SKU{" "}
                <b>
                  {payload.CTAResponse.SkuName} - {payload.CTAResponse.SkuId}
                </b>{" "}
                from order{" "}
                <b>
                  {payload.CTAResponse.OrderName} -{" "}
                  {payload.CTAResponse.OrderId}
                </b>{" "}
                was already {payload.CTAResponse.ApprovalStatus.toLowerCase()}{" "}
                by <b>{payload.CTAResponse.ApproverFullName}</b>.
              </span>
            ),
            type: "info",
            actionRedirectUrl: "/ct/bmo",
            actionRedirectLabel: "Review pending approvals",
          });
        }
        if (!payload.CTAResponse) {
          setEmailNotification(null);
        }
        setReturnList(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          payload.Data.Result.map((order: any) => ({
            ...order,
            isSKUExpanded: false,
          })) || [],
        );
        setTotalReturnPages(payload.Data.TotalPages || 0);
        setTotalReturnRecords(payload.Data.TotalRecord || 0);
        setIsReturnOrdersLoading(false);
      })
      .catch((error: any) => {
        if (isAbortError(error) || (error as any)?.code === "ERR_CANCELED") {
          // Handle abort
          return;
        }
        setIsReturnOrdersError(true);
        setIsReturnOrdersLoading(false);
      });
  };

  const fetchRecoveriesList = () => {
    setIsRecoveriesError(false);
    resetOrderPipelineListState();
    setIsRecoveriesLoading(true);
    setTotalRecoveriesPages(0);
    dispatch(
      fetchRecoveriesListData({
        requestObject: {
          Page: paginationRecoveriesObj.currentPage,
          Record: paginationRecoveriesObj.pageSize,
          BillingType: billingType,
          // StartDate: formatToLocalYYYYMMDD(startDate),
          // EndDate: formatToLocalYYYYMMDD(endDate),
          TransactionDateFilter: transactionDate,
          ...(debouncedSearchValue && { SearchText: debouncedSearchValue }),
        },
      }),
    )
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((action: any) => {
        setOrdersRecoveries(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          action.payload.Result.map((order: any) => ({
            ...order,
            isSKUExpanded: false,
            isOrderExpanded: false,
          })) || [],
        );
        setTotalRecoveriesPages(action.payload.TotalPages || 0);
        setTotalRecoveriesRecords(action.payload.TotalRecord || 0);
        setTotalBilledInRecoveries(action.payload.TotalBilled || 0);
        setIsRecoveriesLoading(false);
      })
      .catch(() => {
        setIsRecoveriesError(true);
        setIsRecoveriesLoading(false);
      });
  };

  const fetchAutoTransactList = () => {
    abortControllerRef &&
      abortControllerRef.current &&
      abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    setIsAutoTransactError(false);
    resetOrderPipelineListState();
    setIsAutoTransactLoading(true);
    setTotalAutoTransactPages(0);
    setTotalAutoTransactRecords(0);
    setTotalBilledAutoTransact(0);
    setOrdersAutoTransact([]);
    dispatch(
      fetchOrderPipelineListData({
        Action: "retrivealltransactionorders",
        Status: "AutoTransaction",
        Page: paginationAutoTransactObj.currentPage,
        Record: paginationAutoTransactObj.pageSize,
        ...(debouncedSearchValue && { SearchText: debouncedSearchValue }),
        StartDate: formatToLocalYYYYMMDD(startDate),
        EndDate: formatToLocalYYYYMMDD(endDate),
        signal: signal,
      }),
    )
      .unwrap()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((payload: any) => {
        if (payload?.Data == undefined) {
          return;
        }
        setOrdersAutoTransact(
          payload.Data.Result.map((order: any) => ({
            ...order,
          })) || [],
        );
        setTotalAutoTransactPages(payload.Data.TotalPages || 0);
        setTotalAutoTransactRecords(payload.Data.TotalRecord || 0);
        setTotalBilledAutoTransact(
          (payload.Data.Result &&
            payload.Data.Result.length > 0 &&
            payload.Data.Result[0].TotalBilled) ||
            0,
        );
        setIsAutoTransactLoading(false);
        setIsAutoTransactError(false);
        setShowAutoTransactPagination(!!payload.Data.TotalPages);
      })
      .catch((error: any) => {
        if (isAbortError(error) || (error as any)?.code === "ERR_CANCELED") {
          // Handle abort
          return;
        }
        setIsAutoTransactError(true);
        setIsAutoTransactLoading(false);
      });
  };

  //Defining functions for Approve and Reject buttons
  const handleApprove = (
    skuId: string,
    orderSkuID: number,
    role: string = "",
    orderParentId: number = 0,
  ) => {
    setSelectedSku(skuId);
    setSelectedOrderSkuId(orderSkuID);
    setSelectedRole(role);
    setSelectedOrderParentId(orderParentId);
    setShowApproveSkuModal(true);
  };

  const handleReject = (
    skuId: string,
    orderSkuID: number,
    role: string = "",
    orderParentId: number = 0,
  ) => {
    setRejectReasonApiError("");
    setSelectedSku(skuId);
    setSelectedOrderSkuId(orderSkuID);
    setSelectedRole(role);
    setSelectedOrderParentId(orderParentId);
    setShowRejectSkuModal(true);
  };

  const approveAndRejectRefreshList = () => {
    removeOrderPipelineQueryParams();
    const canUpdateCurrentPage =
      approvalList.length === 1 && paginationForApprovals.currentPage > 1;
    if (canUpdateCurrentPage) {
      setPaginationForApproval({
        ...paginationForApprovals,
        currentPage: paginationForApprovals.currentPage - 1,
      });
    } else {
      fetchApprovalList();
    }
  };

  const approveSKU = () => {
    const payload: any = {
      SkuId: selectedSku,
      OrderSkuId: selectedOrderSkuId,
      Role: selectedRole,
    };
    if (selectedRole === "order_engagementpartner") {
      payload.OrderParentId = selectedOrderParentId;
    }
    setToastSuccess(false);
    dispatch(approveOrderSku(payload)).then((action: any) => {
      if (action.type.endsWith("fulfilled")) {
        setToastSuccess(true);
        setToastSuccessMessage("SKU order approved.");
        approveAndRejectRefreshList();
        setShowApproveSkuModal(false);
      } else if (action.type.endsWith("rejected")) {
        setToastSuccess(false);
        setShowApproveSkuModal(false);
        console.log(
          "Error approving SKU:",
          action.payload?.message || "Failed to approve SKU",
        );
      }
    });
  };

  const rejectSKU = (rejectSKU: string) => {
    setRejectReasonApiError("");
    const payload: any = {
      SkuId: selectedSku,
      text: rejectSKU,
      OrderSkuId: selectedOrderSkuId,
      Role: selectedRole,
    };
    if (selectedRole === "order_engagementpartner") {
      payload.OrderParentId = selectedOrderParentId;
    }
    setToastSuccess(false);
    dispatch(rejectOrderSku(payload)).then((action: any) => {
      if (action.type.endsWith("fulfilled")) {
        setToastSuccess(true);
        setToastSuccessMessage("SKU order rejected.");
        approveAndRejectRefreshList();
        setRejectReasonApiError("");
        setShowRejectSkuModal(false);
      } else if (action.type.endsWith("rejected")) {
        setToastSuccess(false);
        setRejectReasonApiError(
          action.payload?.message || "Failed to reject SKU",
        );
        console.log(
          "Error rejecting SKU:",
          action.payload?.message || "Failed to reject SKU",
        );
      }
    });
  };

  const handleCancelClick = (orderSkuId: number) => {
    setShowCancelOrderModal(true);
    setSelectedCancelOrder({ Action: "cancelOrder", OrderSkuId: orderSkuId });
  };

  const handleCancelOrder = async () => {
    if (!selectedCancelOrder) {
      return;
    }
    abortControllerRef &&
      abortControllerRef.current &&
      abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    try {
      const requestPayload = {
        Action: selectedCancelOrder.Action,
        OrderSkuId: selectedCancelOrder.OrderSkuId,
        signal: signal,
      };
      setIsCancelOrderLoading(true);
      const response = await dispatch(cancelOrder(requestPayload));
      if (
        response.payload.Status === "success" ||
        response.payload.Code === 200
      ) {
        setIsCancelOrderLoading(false);
        setShowCancelOrderModal(false);
        loadOrderTab(signal);
      } else {
        setIsCancelOrderLoading(false);
        console.error("Failed to cancel order:", response.payload.Message);
      }
    } catch (error) {
      if (isAbortError(error) || (error as any)?.code === "ERR_CANCELED") {
        // Handle abort
        return;
      }
      setIsCancelOrderLoading(false);
      console.error("Failed to cancel order:", error);
    }
  };

  const getFormattedStatus = (status: string) => {
    switch (status) {
      case "order_estimate":
        return (
          <div className="my-estimates">
            <span className="indicator-icon"></span>
            <span>My Estimates</span>
          </div>
        );
      case "order_draft":
        return (
          <div className="my-drafts">
            <span className="indicator-icon"></span>
            <span>My Drafts</span>
          </div>
        );
      case "order_active":
        return (
          <div className="my-orders">
            <span className="indicator-icon"></span>
            <span>My Orders</span>
          </div>
        );
      case "order_submitted":
        return (
          <div className="my-orders">
            <span className="indicator-icon"></span>
            <span>Submitted</span>
          </div>
        );
      case "ordersku_cancelled":
        return (
          <div className="my-orders">
            <span className="indicator-icon"></span>
            <span>Cancelled</span>
          </div>
        );
      default:
        return <div>Unknown Status</div>;
    }
  };

  const toastCloseHandler = () => {
    setToastSuccess(false);
  };

  const orderEstimateColumns = [
    {
      key: "SkuId",
      label: "SKU Name/SKU ID",
      render: (skuData: any) => {
        return (
          <div className="sku-cell-responsive">
            <div className="sku-name-responsive">
              <MotifTruncate maxLines={1} className="sku-truncate-responsive">
                {skuData.Name}
              </MotifTruncate>
            </div>
            <>
              <div className="order-id">{skuData.SkuId}</div>
              <div className="view-sku">
                <div
                  className="view-sku-items"
                  onClick={() => {
                    const updatedOrdersEstimate = ordersEstimate.map(
                      (order: any) => ({
                        ...order,
                        isSKUExpanded:
                          skuData.OrderSkuId === order.OrderSkuId
                            ? !order.isSKUExpanded
                            : false,
                        isOrderExpanded: false,
                      }),
                    );
                    setOrdersEstimate(updatedOrdersEstimate);
                  }}
                >
                  <div>View Sku Details</div>
                  <div>
                    {skuData.isSKUExpanded === true ? (
                      <MotifIcon iconFunction={IconoirNavArrowUp} size="20" />
                    ) : (
                      <MotifIcon iconFunction={IconoirNavArrowDown} size="20" />
                    )}
                  </div>
                </div>
              </div>
            </>
          </div>
        );
      },
    },
    {
      key: "View",
      label: "Order Name/Order ID",
      render: (skuData: any) => (
        <div className="sku-cell-responsive">
          <div className="sku-name-responsive">
            <MotifTruncate maxLines={1} className="sku-truncate-responsive">
              {skuData.Description}
            </MotifTruncate>
          </div>
          <>
            <div className="order-id">{skuData.OrderParentId}</div>
            <div className="view-order">
              <div
                className="view-order-items"
                onClick={() => {
                  const updatedOrdersEstimate = ordersEstimate.map(
                    (order: any) => ({
                      ...order,
                      isOrderExpanded:
                        order.OrderSkuId === skuData.OrderSkuId
                          ? !order.isOrderExpanded
                          : false,
                      isSKUExpanded: false,
                    }),
                  );
                  setOrdersEstimate(updatedOrdersEstimate);
                }}
              >
                <div>
                  {skuData.isOrderExpanded === true
                    ? "Close order details"
                    : "View order details"}
                </div>
                <div>
                  {skuData.isOrderExpanded === true ? (
                    <MotifIcon iconFunction={IconoirNavArrowUp} size="20" />
                  ) : (
                    <MotifIcon iconFunction={IconoirNavArrowDown} size="20" />
                  )}
                </div>
              </div>
            </div>
          </>
        </div>
      ),
    },
    {
      key: "RequestedBy",
      label: "Requested By",
      render: (order: any) => (
        <>
          <div>{order.RequestorName}</div>
          <div className="order-id">{order.RequestorEmail}</div>
        </>
      ),
    },
    {
      key: "CreatedDtm",
      label: "Date Created",
      render: (order: any) => (
        <div className="order-date">{getFormattedDate(order.OrderDate)}</div>
      ),
    },
    {
      key: "Amount",
      label: "Amount",
      render: (order: any) => (
        <div className="order-total">{getTotalOrderAmount(order)}</div>
      ),
    },
    {
      key: "StatusCd",
      label: "Status",
      render: (order: any) => {
        return (
          <div className="order-status">
            {getFormattedStatus(order.OrderStatus)}
          </div>
        );
      },
    },
  ];

  const handleRecoveryRowExpand = (
    SkuId: string,
    OrderParentId: number,
    isRefresh?: boolean,
  ) => {
    setOrdersRecoveries((prev: any[]) =>
      prev.map((order: any) => ({
        ...order,
        isRecoveryExpanded:
          String(order.OrderParentId) === String(OrderParentId) &&
          String(order.SkuId) === String(SkuId)
            ? isRefresh || !order.isRecoveryExpanded
            : false, // Only one row expanded at a time
      })),
    );
    const rowIndex = ordersRecoveries.findIndex(
      (r: any) =>
        String(r.OrderParentId) === String(OrderParentId) &&
        String(r.SkuId) === String(SkuId),
    );
    if (rowIndex === -1) return;

    if (ordersRecoveries[rowIndex]?.responseDetails) {
      setIsRecoveriesDetailsError(false);
      return;
    }

    fetchRecoveryDetails(SkuId, OrderParentId, rowIndex);
  };

  const fetchRecoveryDetails = async (
    SkuId: string,
    OrderParentId: number,
    rowIndex: number,
  ) => {
    setRecoveryDetailsErrorMap((prev) => ({ ...prev, [OrderParentId]: "" }));

    setIsRecoveriesDetailsLoading(true);
    setIsRecoveriesDetailsError(false);

    dispatch(
      fetchRecoveriesListData({
        requestObject: {
          Page: 1,
          Record: 10,
          SkuId,
          OrderId: OrderParentId,
        },
      }),
    )
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((response: any) => {
        if (response.payload?.Status === "success" && response.payload?.Data) {
          setOrdersRecoveries((prev: any[]) => {
            const updated = [...prev];
            updated[rowIndex] = {
              ...updated[rowIndex],
              responseDetails: response.payload.Data,
            };
            return updated;
          });
        } else {
          setRecoveryDetailsErrorMap((prev) => ({
            ...prev,
            [OrderParentId]:
              response.payload?.Message || "Failed to fetch details",
          }));
          setIsRecoveriesDetailsError(true);
        }
        setIsRecoveriesDetailsLoading(false);
      })
      .catch((err) => {
        setRecoveryDetailsErrorMap((prev) => ({
          ...prev,
          [OrderParentId]: "Failed to fetch details",
        }));
        setIsRecoveriesDetailsError(true);
        setIsRecoveriesDetailsLoading(false);

        console.log("Err", err);
      });
  };

  const orderRecoveryColumns = [
    {
      key: "SkuId",
      label: "SKU Name/SKU ID",
      render: (row: any) => (
        <div className="sku-name-responsive">
          <MotifTooltip
            allowHover
            allowClick={false}
            id={`tooltip`}
            placement="auto"
            trigger={
              <span aria-label="Tooltip">
                {truncateString(row.SkuName, 27)}
              </span>
            }
            usePortal
            variant="default"
            hide={row.SkuName.length <= 27}
          >
            {row.SkuName}
          </MotifTooltip>
          <div className="order-id">{row.SkuId}</div>
        </div>
      ),
    },
    {
      key: "OrderName",
      label: "Order Name/ ID",
      render: (skuData: any) => (
        <div className="sku-cell-responsive">
          <div className="sku-name-responsive">
            <MotifTooltip
              allowHover
              allowClick={false}
              id={`tooltip`}
              placement="auto"
              trigger={
                <span aria-label="Tooltip">
                  {truncateString(skuData.Description, 27)}
                </span>
              }
              usePortal
              variant="default"
              hide={skuData.Description.length <= 27}
            >
              {skuData.Description}
            </MotifTooltip>
          </div>
          <div className="order-id">{skuData.OrderParentId}</div>
        </div>
      ),
    },
    {
      key: "Amount",
      label: "Amount",
      render: (order: any) => (
        <div className="order-total">
          {getTotalRecoveriesAmount(order?.Amount)}
        </div>
      ),
    },
    {
      key: "TransactionDate",
      label: "Transaction Date",
      render: (sku: any) => (
        <div>
          <MotifTruncate maxLines={1} maxWidth={200}>
            {getFormattedDate(sku.TransactionDtm)}
          </MotifTruncate>
          <div className="order-id">{getFormattedTime(sku.TransactionDtm)}</div>
        </div>
      ),
    },
    {
      key: "BillingType",
      label: "Billing Type",
      render: (row: any) => (
        <div className="status-badge-billing-type">
          <div>
            {
              billingTypeOptions.find((item) => item.value === row.BillingType)
                ?.label
            }
          </div>
        </div>
      ),
    },
    {
      key: "Increment",
      label: "Transactions Processed",
      render: (row: any) => `${row.IntervalNum} of ${row.Intervals}`,
    },
    {
      key: "EngagementId",
      label: "Engagement ID",
      render: (sku: any) => (
        <div>
          <MotifTruncate maxLines={1} maxWidth={200}>
            {sku.EngagementId}
          </MotifTruncate>
        </div>
      ),
    },
    {
      key: "RecoveryDetails",
      label: "Recovery Details",
      render: (row: any) => (
        <div className="sku-cell-responsive">
          <>
            <div className="view-recovery">
              <div
                className="view-recovery-items"
                onClick={() =>
                  handleRecoveryRowExpand(row.SkuId, row.OrderParentId)
                }
              >
                <div>View Details</div>
                <div>
                  {row.isRecoveryExpanded ? (
                    <MotifIcon iconFunction={IconoirNavArrowUp} size="20" />
                  ) : (
                    <MotifIcon iconFunction={IconoirNavArrowDown} size="20" />
                  )}
                </div>
              </div>
            </div>
          </>
        </div>
      ),
    },
  ];

  const orderColumns = React.useMemo(
    () => [
      {
        key: "SKUName",
        label: "SKU Name/SKU ID",
        render: (skuData: any) => (
          <div className="sku-cell-responsive">
            <div className="sku-name-responsive">
              <MotifTruncate maxLines={1} className="sku-truncate-responsive">
                {skuData.Name}
              </MotifTruncate>
            </div>
            <>
              <div className="order-id">{skuData.SkuId}</div>
              <div className="view-sku">
                <div
                  className="view-sku-items"
                  onClick={() => {
                    const updatedOrders = orders.map((order: any) => ({
                      ...order,
                      isSKUExpanded:
                        skuData.OrderSkuId === order.OrderSkuId
                          ? !order.isSKUExpanded
                          : false,
                      isOrderExpanded: false,
                    }));
                    setOrders(updatedOrders);
                  }}
                >
                  <div>View Sku Details</div>
                  <div>
                    {skuData.isSKUExpanded === true ? (
                      <MotifIcon iconFunction={IconoirNavArrowUp} size="20" />
                    ) : (
                      <MotifIcon iconFunction={IconoirNavArrowDown} size="20" />
                    )}
                  </div>
                </div>
              </div>
            </>
          </div>
        ),
      },
      {
        key: "OrderName",
        label: "Order Name/Order ID",
        render: (skuData: any) => (
          <div className="sku-cell-responsive">
            <div className="sku-name-responsive">
              <MotifTruncate maxLines={1} className="sku-truncate-responsive">
                {skuData.Description}
              </MotifTruncate>
            </div>
            <>
              <div className="order-id">{skuData.OrderParentId}</div>
              <div className="view-order">
                <div
                  className="view-order-items"
                  onClick={() => {
                    const updatedOrders = orders.map((order: any) => ({
                      ...order,
                      isOrderExpanded:
                        order.OrderSkuId === skuData.OrderSkuId
                          ? !order.isOrderExpanded
                          : false,
                      isSKUExpanded: false,
                    }));
                    setOrders(updatedOrders);
                  }}
                >
                  <div>
                    {skuData.isOrderExpanded === true
                      ? "Close order details"
                      : "View order details"}
                  </div>
                  <div>
                    {skuData.isOrderExpanded === true ? (
                      <MotifIcon iconFunction={IconoirNavArrowUp} size="20" />
                    ) : (
                      <MotifIcon iconFunction={IconoirNavArrowDown} size="20" />
                    )}
                  </div>
                </div>
              </div>
            </>
          </div>
        ),
      },
      {
        key: "EngName",
        label: "Eng ID/Eng Name",
        render: (sku: any) => (
          <div>
            <div>{sku.EngagementId}</div>
            <div className="order-id">
              <MotifTruncate maxLines={1} maxWidth={200}>
                {sku.EngagementName}
              </MotifTruncate>
            </div>
          </div>
        ),
      },
      {
        key: "RequestorId",
        label: "Requested By",
        render: (sku: any) => (
          <div>
            <MotifTruncate maxLines={1} maxWidth={200}>
              {sku.RequestorName}
            </MotifTruncate>
            <div className="order-id">{sku.RequestorEmail}</div>
          </div>
        ),
      },
      {
        key: "ReqDate",
        label: "Req. Date",
        render: (sku: any) => (
          <div>
            <MotifTruncate maxLines={1} maxWidth={200}>
              {getFormattedDate(sku.OrderDate)}
            </MotifTruncate>
            <div className="order-id">{getFormattedTime(sku.OrderDate)}</div>
          </div>
        ),
      },
      {
        key: "Total",
        label: "Amount",
        render: (order: any) => (
          <div className="order-total">
            {order?.TotalCost.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })}
          </div>
        ),
      },
      {
        key: "StatusCd",
        label: "Approval Status",
        render: (order: any) => (
          <div className="sku-status">
            {order["Engagement"] !== undefined && (
              <ApprovalStatusPopover
                stage="engagement"
                rawStatus={order.Engagement.Status}
                approvers={order.Engagement.Users}
                RejectionReasonInfo={order.Engagement.RejectionReason}
                isAutoProvisioned={order.IsAutoProvisioned}
              />
            )}
            <div className="sku-status__product-provision">
              {order["Product"] !== undefined && (
                <ApprovalStatusPopover
                  stage="product"
                  rawStatus={order.Product.Status}
                  approvers={order.Product.Users}
                  RejectionReasonInfo={order.Product.RejectionReason}
                />
              )}
              {order["Deploy"] !== undefined && (
                <ApprovalStatusPopover
                  stage="provision"
                  rawStatus={order.Deploy.Status}
                  approvers={order.Deploy.Users}
                  RejectionReasonInfo={order.Deploy.RejectionReason}
                  isAutoProvisioned={order.IsAutoProvisioned}
                />
              )}
            </div>
            {order["LocalRisk"] !== undefined && (
              <ApprovalStatusPopover
                stage="localRisk"
                rawStatus={order.LocalRisk.Status}
                approvers={order.LocalRisk.Users}
                RejectionReasonInfo={order.LocalRisk.RejectionReason}
              />
            )}
            {order["GlobalRisk"] !== undefined && (
              <ApprovalStatusPopover
                stage="globalRisk"
                rawStatus={order.GlobalRisk.Status}
                approvers={order.GlobalRisk.Users}
                RejectionReasonInfo={order.GlobalRisk.RejectionReason}
              />
            )}
            {order["Extension"] !== undefined && (
              <ApprovalStatusPopover
                stage="extension"
                rawStatus={order.Extension.Status}
                approvers={order.Extension.Users}
                RejectionReasonInfo={order.Extension.RejectionReason}
                isAutoProvisioned={order.IsAutoProvisioned}
              />
            )}
          </div>
        ),
      },
      {
        key: "OrderSkuStatus",
        label: "Provision Status",
        render: (order: any) => (
          <>
            {order?.Extension &&
            !order.IsAutoProvisioned &&
            order?.Extension?.Status === "0" ? (
              <p>Your request is rejected by the engagement approver</p>
            ) : order?.Extension &&
              !order.IsAutoProvisioned &&
              order?.Extension?.Status === "" ? (
              <p>Extension needs engagement approval</p>
            ) : order?.Engagement &&
              !order.IsAutoProvisioned &&
              order?.Engagement?.Status === "0" ? (
              <p>Your request is rejected by the engagement approver</p>
            ) : order?.Engagement &&
              !order.IsAutoProvisioned &&
              order?.Engagement?.Status === "" ? (
              <p>Need engagement approval</p>
            ) : (
              <div className="order-status">
                {order?.OrderSkuStatus && (
                  <MotifSelect
                    onChange={(statusCol) => {
                      if (statusCol === order.OrderSkuStatus) return null;
                      if (statusCol === "ordersku_submitted") {
                        handleStatusChange(String(statusCol), order);
                      } else if (statusCol !== "ordersku_submitted") {
                        setSelectedSkuData(order);
                        setTempProvisionStatus(statusCol);
                        setShowProvisioningModal(true);
                      }
                    }}
                    id={order.OrderSkuId.toString()}
                    value={order.OrderSkuStatus}
                    disabled={
                      order.OrderSkuStatus === "ordersku_active" ||
                      !disableSku(order)
                    }
                    visibleOptions={3}
                  >
                    {statusOptions.map((option) => (
                      <MotifOption key={option.value} value={option.value}>
                        {option.label}
                      </MotifOption>
                    ))}
                  </MotifSelect>
                )}
              </div>
            )}
          </>
        ),
      },
      {
        key: "Completion Date",
        label: "Projected Completion Date",
        render: (order: any) => (
          <div>
            <MotifDatePicker
              clearIcon={null}
              dayPlaceholder="DD"
              format="dd/MM/yyyy"
              maxDate={new Date(NaN)}
              minDate={new Date(NaN)}
              monthPlaceholder="MM"
              disabled={
                order.OrderSkuStatus === "ordersku_active" ||
                !disableSku(order) ||
                order.IsAutoProvisioned ||
                (order?.Engagement && order?.Engagement?.Status !== "1")
              }
              onCalendarClose={() => {}}
              onCalendarOpen={() => {}}
              onChange={(date) => {
                onDateChange(date, order);
              }}
              value={
                rowDates[order.OrderSkuId] ??
                (order.OrderSkuStatus === "ordersku_active"
                  ? isEmpty(order.SKUProvisionDtm)
                    ? null
                    : convertDateStringtoDate(order.SKUProvisionDtm)
                  : isEmpty(order.ProvisionDtm)
                    ? null
                    : convertDateStringtoDate(order.ProvisionDtm))
              }
              yearPlaceholder="YYYY"
            />
            {validationError[order.OrderSkuId] && (
              <MotifErrorMessage>
                {validationError[order.OrderSkuId]}
              </MotifErrorMessage>
            )}
          </div>
        ),
      },
      {
        key: "action",
        label: "Action",
        render: (order: any) => (
          <div className="order-action">
            <MotifDropdown
              ariaLabelledby="action-dropdown"
              closeOnOutsideClick={true}
              placement="bottom-start"
              trigger={
                <MotifButton
                  aria-label="action menu"
                  type="button"
                  variant="secondary"
                  size="small"
                >
                  <MotifIcon
                    iconFunction={IconoirMoreHoriz}
                    strokeWidth="2px"
                  />
                </MotifButton>
              }
            >
              {order.IsCancelAllowed ? (
                <MotifDropdownItem
                  disabled={!order.IsCancelAllowed}
                  onClick={() => {
                    handleCancelClick(order.OrderSkuId);
                  }}
                >
                  <MotifIcon
                    iconFunction={IconoirXmarkCircle}
                    size="20"
                    title="Cancel SKU"
                    fill={order.IsCancelAllowed ? "currentColor" : "#737387"}
                  />
                  Cancel SKU
                </MotifDropdownItem>
              ) : (
                <MotifTooltip
                  contentClassName="tooltip-content"
                  allowClick={false}
                  allowHover
                  id={`tooltip1`}
                  placement="top"
                  trigger={
                    <MotifDropdownItem
                      disabled={!order.IsCancelAllowed}
                      onClick={() => {
                        handleCancelClick(order.OrderSkuId);
                      }}
                    >
                      <MotifIcon
                        iconFunction={IconoirXmarkCircle}
                        size="20"
                        title="Cancel SKU"
                        fill={
                          order.IsCancelAllowed ? "currentColor" : "#737387"
                        }
                      />
                      Cancel SKU
                    </MotifDropdownItem>
                  }
                  usePortal
                  variant="default"
                >
                  {order.CostIntervalCd === "onetime"
                    ? "This SKU is a one-time cost and can't be canceled."
                    : order.RemainingBillingPeriods <= 0
                      ? "Cancellation is only available for products that are actively in use and being billed."
                      : "This product is already being provisioned and can’t be canceled."}
                </MotifTooltip>
              )}
              {order.IsReturnAllowed ? (
                <MotifDropdownItem
                  onClick={() => {
                    setShowReturnOrderModal(true);
                    setSelectedSkuData(order);
                  }}
                  disabled={!order?.IsReturnAllowed}
                >
                  <MotifIcon
                    iconFunction={IconoirArrowLeftCircle}
                    size="20"
                    title="Return SKU"
                    fill={order.IsReturnAllowed ? "currentColor" : "#737387"}
                  />
                  Return SKU
                </MotifDropdownItem>
              ) : (
                <MotifTooltip
                  contentClassName="tooltip-content"
                  allowClick={false}
                  allowHover
                  id={`tooltip2`}
                  placement="top"
                  trigger={
                    <MotifDropdownItem
                      onClick={() => {
                        setShowReturnOrderModal(true);
                        setSelectedSkuData(order);
                      }}
                      disabled={!order?.IsReturnAllowed}
                    >
                      <MotifIcon
                        iconFunction={IconoirArrowLeftCircle}
                        size="20"
                        title="Return SKU"
                        fill={
                          order.IsReturnAllowed ? "currentColor" : "#737387"
                        }
                      />
                      Return SKU
                    </MotifDropdownItem>
                  }
                  usePortal
                  variant="default"
                >
                  {order.OrderSkuStatus !== "ordersku_active"
                    ? "You can only return a SKU once the product is provisioned."
                    : "This SKU cannot be returned."}
                </MotifTooltip>
              )}
              {order.IsSkuExtensionAllowed ? (
                <MotifDropdownItem
                  onClick={() => {
                    navigate(
                      `/order-extension/${order.OrderParentId}/sku-id/${order.OrderSkuId}`,
                    );
                  }}
                  disabled={!order?.IsSkuExtensionAllowed}
                >
                  <MotifIcon
                    iconFunction={IconoirArrowRightCircle}
                    size="20"
                    title="Extend SKU"
                    fill={
                      order?.IsSkuExtensionAllowed ? "currentColor" : "#737387"
                    }
                  />
                  Extend SKU
                </MotifDropdownItem>
              ) : (
                <MotifTooltip
                  contentClassName="tooltip-content"
                  allowClick={false}
                  allowHover
                  id={`tooltip3`}
                  placement="top"
                  trigger={
                    <MotifDropdownItem
                      onClick={() => {}}
                      disabled={!order?.IsSkuExtensionAllowed}
                    >
                      <MotifIcon
                        iconFunction={IconoirArrowRightCircle}
                        size="20"
                        title="Extend SKU"
                        fill={
                          order?.IsSkuExtensionAllowed
                            ? "currentColor"
                            : "#737387"
                        }
                      />
                      Extend SKU
                    </MotifDropdownItem>
                  }
                  usePortal
                  variant="default"
                >
                  {order.CostIntervalCd === "onetime"
                    ? "This SKU cannot be extended; only weekly or monthly SKUs are eligible."
                    : order.OrderSkuStatus === "ordersku_submitted" ||
                        order.OrderSkuStatus === "ordersku_pending"
                      ? "You can only extend a SKU once the product is provisioned."
                      : order.RemainingBillingPeriods <= 0
                        ? "You can only extend an SKU while it is actively in use and being billed."
                        : "This SKU cannot be extended."}
                </MotifTooltip>
              )}
              {order.IsExtensionAllowed ? (
                <MotifDropdownItem
                  onClick={() => {
                    navigate(`/order-extension/${order.OrderParentId}`);
                  }}
                  disabled={!order?.IsExtensionAllowed}
                >
                  <MotifIcon
                    iconFunction={IconoirArrowRightCircle}
                    size="20"
                    title="Extend Order"
                    fill={
                      order?.IsExtensionAllowed ? "currentColor" : "#737387"
                    }
                  />
                  Extend Order
                </MotifDropdownItem>
              ) : (
                <MotifTooltip
                  contentClassName="tooltip-content"
                  allowClick={false}
                  allowHover
                  id={`tooltip4`}
                  placement="top"
                  hideCloseButton={true}
                  trigger={
                    <MotifDropdownItem
                      onClick={() => {
                        navigate(`/order-extension/${order.OrderParentId}`);
                      }}
                      disabled={!order?.IsExtensionAllowed}
                    >
                      <MotifIcon
                        iconFunction={IconoirArrowRightCircle}
                        size="20"
                        title="Extend Order"
                        fill={
                          order?.IsExtensionAllowed ? "currentColor" : "#737387"
                        }
                      />
                      Extend Order
                    </MotifDropdownItem>
                  }
                  usePortal
                  variant="default"
                >
                  {order.CostIntervalCd === "onetime"
                    ? "This order cannot be extended; only weekly or monthly SKUs are eligible."
                    : order.OrderSkuStatus === "ordersku_submitted" ||
                        order.OrderSkuStatus === "ordersku_pending"
                      ? "You can only extend an order once the product is provisioned."
                      : order.RemainingBillingPeriods <= 0
                        ? "You can only extend an order while it is actively in use and being billed."
                        : "This order cannot be extended."}
                </MotifTooltip>
              )}
            </MotifDropdown>
          </div>
        ),
      },
    ],
    [orders, rowDates, validationError],
  );

  const toggleDropdown = () => {
    setIsToggleOpen(!isToggleOpen);
  };
  //Cancelled Order
  const cancelledOrderColumns = [
    {
      key: "SKUName",
      label: "SKU Name/SKU ID",
      render: (skuData: any) => (
        <div className="sku-cell-responsive">
          <div className="sku-name-responsive">
            <MotifTruncate maxLines={1} className="sku-truncate-responsive">
              {skuData.Name}
            </MotifTruncate>
          </div>
          <>
            <div className="order-id">{skuData.SkuId}</div>
            <div className="view-sku">
              <div
                className="view-sku-items"
                onClick={() => {
                  const updatedOrders = cancelledOrders.map((order: any) => ({
                    ...order,
                    isSKUExpanded:
                      skuData.OrderSkuId === order.OrderSkuId
                        ? !order.isSKUExpanded
                        : false,
                    isOrderExpanded: false,
                  }));
                  setCancelledOrders(updatedOrders);
                }}
              >
                <div>View Sku Details</div>
                <div>
                  {skuData.isSKUExpanded === true ? (
                    <MotifIcon iconFunction={IconoirNavArrowUp} size="20" />
                  ) : (
                    <MotifIcon iconFunction={IconoirNavArrowDown} size="20" />
                  )}
                </div>
              </div>
            </div>
          </>
        </div>
      ),
    },
    {
      key: "OrderName",
      label: "Order Name/Order ID",
      render: (skuData: any) => (
        <div className="sku-cell-responsive">
          <div className="sku-name-responsive">
            <MotifTruncate maxLines={1} className="sku-truncate-responsive">
              {skuData.Description}
            </MotifTruncate>
          </div>
          <>
            <div className="order-id">{skuData.OrderParentId}</div>
            <div className="view-order">
              <div
                className="view-order-items"
                onClick={() => {
                  const updatedCancelledOrders = cancelledOrders.map(
                    (order: any) => ({
                      ...order,
                      isOrderExpanded:
                        order.OrderSkuId === skuData.OrderSkuId
                          ? !order.isOrderExpanded
                          : false,
                      isSKUExpanded: false,
                    }),
                  );
                  setCancelledOrders(updatedCancelledOrders);
                }}
              >
                <div>
                  {skuData.isOrderExpanded === true
                    ? "Close order details"
                    : "View order details"}
                </div>
                <div>
                  {skuData.isOrderExpanded === true ? (
                    <MotifIcon iconFunction={IconoirNavArrowUp} size="20" />
                  ) : (
                    <MotifIcon iconFunction={IconoirNavArrowDown} size="20" />
                  )}
                </div>
              </div>
            </div>
          </>
        </div>
      ),
    },
    {
      key: "RequestorId",
      label: "Requested By",
      render: (sku: any) => (
        <div>
          <MotifTruncate maxLines={1} maxWidth={200}>
            {sku.RequestorName}
          </MotifTruncate>
          <div className="order-id">{sku.RequestorEmail}</div>
        </div>
      ),
    },
    {
      key: "Total",
      label: "Amount",
      render: (order: any) => (
        <div className="order-total">{getTotalOrderAmount(order)}</div>
      ),
    },
    {
      key: "CancelledDate",
      label: "Cancelled Date",
      render: (order: any) => (
        <div>
          <MotifTruncate maxLines={1} maxWidth={200}>
            {getFormattedDate(order.CancelledDate)}
          </MotifTruncate>
          <div className="order-id">
            {getFormattedTime(order.CancelledDate)}
          </div>
        </div>
      ),
    },
    {
      key: "OrderSkuStatus",
      label: "Status",
      render: (order: any) => (
        <div className="order-status">
          {getFormattedStatus(order.OrderSkuStatus)}
        </div>
      ),
    },
  ];

  const parseDate = (dateString: string | null | undefined) => {
    if (!dateString) return null;
    const datePart = dateString.split("T")[0];
    const dateObj = new Date(datePart);
    return isNaN(dateObj.getTime()) ? null : dateObj;
  };

  const statusOptions = [
    { value: "ordersku_submitted", label: "Not Started" },
    { value: "ordersku_pending", label: "In Progress" },
    { value: "ordersku_active", label: "Completed" },
  ];

  const orderStatusOptions = [
    { value: "all", label: "All" },
    { value: "draft", label: "Drafts" },
    { value: "estimate", label: "Estimates" },
  ];

  const billingTypeOptions = [
    { value: "", label: "All" },
    {
      value: "skubill_countryengagement",
      label: "Country + Engagement Billed",
    },
    { value: "skubill_country", label: "Country Billed" },
    { value: "skubill_engagement", label: "Engagement Billed" },
    { value: "skubill_notbilled", label: "Not Billed" },
    { value: "skubill_surcharge", label: "Surcharge" },
  ];

  const requestDateOptions = [
    { value: "", label: "All" },
    { value: "Last 30 Days", label: "Last 30 Days" },
    { value: "YTD", label: "Year to date(YTD)" },
    { value: "Last 365 Days", label: "Last 365 Days" },
  ];

  // const skuNameOptions = [
  //   { value: "", label: "All" },
  //   { value: "Single Tenant Small", label: "Single Tenant Small" },
  //   { value: "Power BI License", label: "Power BI License" },
  //   { value: "XYZ Engagement", label: "XYZ Engagement" },
  // ];

  // const productOptions = [
  //   { value: "", label: "All" },
  //   { value: "AssignmentPro", label: "AssignmentPro" },
  //   {
  //     value: "Bubbly Blasters (non-Empire)",
  //     label: "Bubbly Blasters (non-Empire)",
  //   },
  //   { value: "Archive Records Center", label: "Archive Records Center" },
  // ];

  // const transactionOptions = [
  //   { value: "", label: "All" },
  //   { value: "Completed", label: "Completed" },
  //   { value: "Failed", label: "Failed" },
  //   { value: "Pending", label: "Pending" },
  // ];

  const handleStatusChange = (statusCol: string, order: any) => {
    setHasUserSelectedStatus(true);

    let completionDate = null;

    if (rowDates[order.OrderSkuId]) {
      completionDate =
        typeof rowDates[order.OrderSkuId] === "string"
          ? rowDates[order.OrderSkuId]
          : formatToLocalYYYYMMDD(rowDates[order.OrderSkuId]);
    } else {
      completionDate =
        order.OrderSkuStatus === "ordersku_active"
          ? parseDate(order.SKUProvisionDtm)
          : parseDate(order.ProvisionDtm);
    }

    setStatusCol(statusCol);
    saveStatus(statusCol, completionDate, order);
  };

  const handleClearBtn = () => {
    if (selectedTab === 0) {
      const isDateNull = dateRange?.[0] === null && dateRange?.[1] === null;
      if (isDateNull && orderStatus === "all") {
        setIsClearEstimateBtnDisabled(true);
      } else {
        setIsClearEstimateBtnDisabled(false);
      }
    } else if (selectedTab === 1) {
      const isDateNull = dateRange?.[0] === null && dateRange?.[1] === null;
      const isProvStatusAll =
        Array.isArray(selectedProvStatusInOrder) &&
        selectedProvStatusInOrder.length === 0;
      if (isProvStatusAll && isDateNull) {
        setIsClearOrderBtnDisabled(true);
      } else {
        setIsClearOrderBtnDisabled(false);
      }
    } else if (selectedTab === 2) {
      const isDateNull = dateRange?.[0] === null && dateRange?.[1] === null;
      if (isDateNull) {
        setIsClearApprovalBtnDisabled(true);
      } else {
        setIsClearApprovalBtnDisabled(false);
      }
    } else if (selectedTab === 3) {
      const isDateNull = dateRange?.[0] === null && dateRange?.[1] === null;
      if (isDateNull) {
        setIsClearCancelledBtnDisabled(true);
      } else {
        setIsClearCancelledBtnDisabled(false);
      }
    } else if (selectedTab === 5) {
      const isDateNull = dateRange?.[0] === null && dateRange?.[1] === null;
      if (isDateNull && billingType === "" && transactionDate === "") {
        setIsClearRecoveriesBtnDisabled(true);
      } else {
        setIsClearRecoveriesBtnDisabled(false);
      }
    } else if (selectedTab === 4) {
      if (
        selectedReturnStatus.length == 0 &&
        selectedReturnType.length == 0 &&
        selectedReturnRequestedDate === "All"
      ) {
        setIsClearReturnBtnDisabled(true);
      } else {
        setIsClearReturnBtnDisabled(false);
      }
    }
    // else if (selectedTab === 6) {
    //   const isDateNull = dateRange?.[0] === null && dateRange?.[1] === null;
    //   if (
    //     isDateNull &&
    //     selectedSkuName === "" &&
    //     selectedProductName === "" &&
    //     selectedTransactionStatus === ""
    //   ) {
    //     setIsClearAutoTransactBtnDisabled(true);
    //   } else {
    //     setIsClearAutoTransactBtnDisabled(false);
    //   }
    // }
  };

  const handleOrderStatusChange = (statusCol?: string) => {
    removeOrderPipelineQueryParams();
    const nextStatus = statusCol && statusCol.trim() ? statusCol : "all";
    setOrderStatus(nextStatus);
    setIsClearEstimateBtnDisabled(false);
    setIsClearOrderBtnDisabled(false);
    setPaginationEstimateObj((prev: any) => ({
      ...prev,
      Status: nextStatus,
      currentPage: 1,
    }));
  };

  const handleProvisioningStatusChange = (provCol: string[]) => {
    removeOrderPipelineQueryParams();
    setSelectedProvStatusInOrder(provCol);
    setIsClearOrderBtnDisabled(false);

    if (ordersFilterTimerRef.current) {
      clearTimeout(ordersFilterTimerRef.current);
    }

    ordersFilterTimerRef.current = setTimeout(() => {
      setPaginationOrdersObj((prev: any) => ({
        ...prev,
        ProvisioningStatus: provCol.length ? provCol : ["all"],
        currentPage: 1,
      }));
      ordersFilterTimerRef.current = null;
    }, 500);
  };

  const handleBillingTypeChange = (type?: string) => {
    const defaultBillingType = billingTypeOptions[0].value;
    const nextBillingType =
      type && String(type).trim() ? String(type) : defaultBillingType;

    setBillingType(nextBillingType);
    setIsClearRecoveriesBtnDisabled(false);
    setPaginationRecoveriesObj((prev: any) => ({
      ...prev,
      currentPage: 1,
      BillingType: nextBillingType,
    }));
  };

  const handleTransactionDateChange = (transaction?: string) => {
    const defaultTransactionDate = requestDateOptions[0].value;
    const nextTransactionDate =
      transaction && String(transaction).trim()
        ? String(transaction)
        : defaultTransactionDate;

    setTransactionDate(nextTransactionDate);
    setIsClearRecoveriesBtnDisabled(false);
    setPaginationRecoveriesObj((prev: any) => ({
      ...prev,
      currentPage: 1,
      TransactionDateFilter: nextTransactionDate,
    }));
  };

  const handleReturnRequestedDateChange = (type?: string) => {
    removeOrderPipelineQueryParams();
    const defaultRequestedDate = returnRequestedDateOptions[0].value;
    const nextRequestedDate =
      type && String(type).trim() ? String(type) : defaultRequestedDate;

    setSelectedReturnRequestedDate(nextRequestedDate);
    setIsClearReturnBtnDisabled(false);
    setPaginationForReturn((prev: any) => ({
      ...prev,
      RequestedDate: nextRequestedDate,
      currentPage: 1,
    }));
  };

  // const handleSkuNameChange = (skuName: string) => {
  //   setSelectedSkuName(skuName);
  //   setIsClearAutoTransactBtnDisabled(false);
  //   setPaginationAutoTransactObj((prev: any) => ({
  //     ...prev,
  //     currentPage: 1,
  //     SkuName: skuName,
  //   }));
  // };

  // const handleProductChange = (product: string) => {
  //   setSelectedProductName(product);
  //   setIsClearAutoTransactBtnDisabled(false);
  //   setPaginationAutoTransactObj((prev: any) => ({
  //     ...prev,
  //     currentPage: 1,
  //     ProductName: product,
  //   }));
  // };

  // const handleTransactionStatusChange = (status: string) => {
  //   setSelectedTransactionStatus(status);
  //   setIsClearAutoTransactBtnDisabled(false);
  //   setPaginationAutoTransactObj((prev: any) => ({
  //     ...prev,
  //     currentPage: 1,
  //     TransactionStatus: status,
  //   }));
  // };

  const saveStatus = async (newStatus: string, date: any, order: any) => {
    const requestDetails: deploymentApproverObject = {
      orderSkuId: order.OrderSkuId,
      statusCd: newStatus,
    };
    const UTCDate: any = formatToUTCYYYYMMDD(new Date(date));
    if (newStatus === "ordersku_active") {
      requestDetails["completionDate"] = UTCDate || null;
    } else if (date) {
      requestDetails["completionDate"] = UTCDate;
    }
    abortControllerRef &&
      abortControllerRef.current &&
      abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    try {
      const response = await dispatch(
        deployementApproverProvStatus(requestDetails),
      );
      if (!response) throw new Error("Failed to save status");

      if (
        response.payload?.statusMessage ===
          "Order SKU status updated successfully" ||
        response.payload?.Code === 200
      ) {
        setValidationError((prev) => {
          const updated = { ...prev };
          delete updated[order.OrderSkuId];
          return updated;
        });
        removeOrderPipelineQueryParams();
        loadOrderTab(signal);
        setHasUserSelectedStatus(false);
        setShowProvisioningModal(false);
        setToastSuccess(true);
        setToastSuccessMessage(
          newStatus === "ordersku_active"
            ? "SKU completion complete"
            : newStatus === "ordersku_pending"
              ? "SKU provision marked in progress"
              : "Order details have been successfully updated.",
        );
      } else {
        setValidationError((prev) => ({
          ...prev,
          [order.OrderSkuId]: "completion date is missing or invalid",
        }));
      }
    } catch (error) {
      if (isAbortError(error) || (error as any)?.code === "ERR_CANCELED") {
        // Handle abort
        return;
      }
      console.error(error);
    }
  };

  const onDateChange = (date: any, order: any) => {
    setRowDates((prev) => ({
      ...prev,
      [order.OrderSkuId]: date,
    }));
    const completionDate = formatToLocalYYYYMMDD(date);
    const statusToUse = hasUserSelectedStatus
      ? statusCol
      : order.OrderSkuStatus;

    saveStatus(statusToUse, completionDate, order);
  };

  const dateHandler = (date: any, order: any) => {
    setRowDates((prev) => ({
      ...prev,
      [order.OrderSkuId]: date,
    }));
  };

  const getUserRole = (role: string = "") => {
    switch (role) {
      case "sku_productapprover":
        return "Product Approver";
      case "sku_deploymentapprover":
        return "Provisioning Team";
      case "sku_localriskmgr":
        return "Local Risk Manager";
      case "sku_globalriskmgr":
        return "Global Risk Manager";
      case "order_engagementpartner":
      case "engagement_delegate":
        return "Engagement Partner";
      default:
        return "";
    }
  };

  const downloadOrderCsvFile = async (SearchText: string) => {
    setExportSuccessMessage("");
    setExportErrorMessage("");
    setIsCSVLoading(true);
    try {
      const currentQueryParams = new URLSearchParams(window.location.search);
      const orderId = currentQueryParams.get("OrderId");
      const skuId = currentQueryParams.get("SkuId");
      const source = currentQueryParams.get("Source");
      const role = currentQueryParams.get("Role");
      const orderSkuIdValue = currentQueryParams.get("OrderSkuId");
      const orderSkuId = orderSkuIdValue ? Number(orderSkuIdValue) : undefined;

      const payload = {
        Action: "getAllOrderExportData",
        SearchText,
        StartDate: formatToLocalYYYYMMDD(startDate),
        EndDate: formatToLocalYYYYMMDD(endDate),
        ProvisioningStatus: selectedProvStatusInOrder.length
          ? selectedProvStatusInOrder
          : ["all"],
        ...(orderId && { OrderId: orderId }),
        ...(skuId && { SkuId: skuId }),
        ...(source && { Source: source }),
        ...(role && { Role: role }),
        ...(orderSkuId && { OrderSkuId: orderSkuId }),
      };

      const response = await dispatch(fetchOrderExportData(payload));
      if (response.payload?.message) {
        setIsCSVLoading(false);
        setExportSuccessMessage("");
        setExportErrorMessage("Something went wrong. Please try again.");
      } else {
        setExportErrorMessage("");
        const blob = new Blob([response.payload], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const yyyy = today.getFullYear();
        const fileName = `Order Export - ${mm}${dd}${yyyy}.csv`;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        setIsCSVLoading(false);
        setExportSuccessMessage("The CSV File has been downloaded succesfully");
      }
    } catch (error) {
      setIsCSVLoading(false);
      console.error("Failed to place order:", error);
      setExportSuccessMessage("");
      setExportErrorMessage("Something went wrong. Please try again.");
    }
  };

  const approvalTableColumns = [
    {
      key: "SKUName",
      label: "SKU Name/SKU ID",
      render: (skuData: OrderData) => (
        <div className="sku-cell-responsive">
          <div className="sku-name-responsive">
            <MotifTruncate maxLines={1} className="sku-truncate-responsive">
              {skuData.Name}
            </MotifTruncate>
          </div>
          <>
            <div className="order-id">{skuData.SkuId}</div>
            <div className="view-sku">
              <div
                className="view-sku-items"
                onClick={() => {
                  const updatedApprovalList = approvalList.map(
                    (record: any) => ({
                      ...record,
                      isSKUExpanded:
                        skuData.OrderSkuId === record.OrderSkuId &&
                        skuData.Role === record.Role
                          ? !record.isSKUExpanded
                          : false,
                      isOrderExpanded: false,
                    }),
                  );
                  setApprovalList(updatedApprovalList);
                }}
              >
                <div>View Sku Details</div>
                <div>
                  {skuData.isSKUExpanded === true ? (
                    <MotifIcon iconFunction={IconoirNavArrowUp} size="20" />
                  ) : (
                    <MotifIcon iconFunction={IconoirNavArrowDown} size="20" />
                  )}
                </div>
              </div>
            </div>
          </>
        </div>
      ),
    },
    {
      key: "OrderName",
      label: "Order Name/Order ID",
      render: (skuData: OrderData) => (
        <div className="sku-cell-responsive">
          <div className="sku-name-responsive">
            <MotifTruncate maxLines={1} className="sku-truncate-responsive">
              {skuData.Description}
            </MotifTruncate>
          </div>
          <>
            <div className="order-id">{skuData.OrderParentId}</div>
            <div className="view-order">
              <div
                className="view-order-items"
                onClick={() => {
                  const updatedApprovalList = approvalList.map(
                    (record: any) => ({
                      ...record,
                      isOrderExpanded:
                        record.OrderSkuId === skuData.OrderSkuId &&
                        record.Role === skuData.Role
                          ? !record.isOrderExpanded
                          : false,
                      isSKUExpanded: false,
                    }),
                  );
                  setApprovalList(updatedApprovalList);
                }}
              >
                <div>
                  {skuData.isOrderExpanded === true
                    ? "Close order details"
                    : "View order details"}
                </div>
                <div>
                  {skuData.isOrderExpanded === true ? (
                    <MotifIcon iconFunction={IconoirNavArrowUp} size="20" />
                  ) : (
                    <MotifIcon iconFunction={IconoirNavArrowDown} size="20" />
                  )}
                </div>
              </div>
            </div>
          </>
        </div>
      ),
    },
    {
      key: "EngName",
      label: "Eng Name/ID",
      render: (sku: any) => (
        <div className="sku-name-responsive">
          <MotifTruncate maxLines={1} className="sku-truncate-responsive">
            {sku.EngagementName}
          </MotifTruncate>
          <div className="order-id">{sku.EngagementId}</div>
        </div>
      ),
    },
    {
      key: "RequestorId",
      label: "Requested By",
      render: (sku: OrderData) => (
        <div>
          <MotifTruncate maxLines={1} maxWidth={200}>
            {sku.RequestorName}
          </MotifTruncate>
          <div className="order-id">{sku.RequestorEmail}</div>
        </div>
      ),
    },
    {
      key: "ReqDate",
      label: "Req. Date",
      render: (sku: OrderData) => (
        <div>
          <MotifTruncate maxLines={1} maxWidth={200}>
            {getFormattedDate(sku.OrderDate)}
          </MotifTruncate>
          <div className="order-id">{getFormattedTime(sku.OrderDate)}</div>
        </div>
      ),
    },
    {
      key: "Total",
      label: "Amount",
      render: (sku: OrderData) => (
        <div className="order-total">{getTotalOrderAmount(sku)}</div>
      ),
    },
    {
      key: "UserRole",
      label: "User Role",
      render: (record: OrderData) => <div>{getUserRole(record.Role)}</div>,
    },
    {
      key: "StatusCd",
      label: "Status",
      render: () => (
        <div className="status-badge pending">
          <div>Pending</div>
          <MotifIcon
            className="approval-pending-icon"
            iconFunction={IconoirTimer}
          />
        </div>
      ),
    },
    {
      key: "Action",
      label: "Action",
      render: (record: OrderData) => (
        <div className="action-btns">
          <MotifButton
            onClick={() =>
              handleReject(
                record.SkuId,
                record.OrderSkuId,
                record.Role,
                record.OrderParentId,
              )
            }
            className="order-reject-btn"
          >
            <MotifIcon iconFunction={IconoirXmark} size="16" />
            Reject
          </MotifButton>
          <MotifButton
            onClick={() =>
              handleApprove(
                record.SkuId,
                record.OrderSkuId,
                record.Role,
                record.OrderParentId,
              )
            }
            className="order-approve-btn"
          >
            <MotifIcon iconFunction={IconoirCheck} size="16" />
            Approve
          </MotifButton>
        </div>
      ),
    },
  ];

  const getCostTypeLabel = (costType: string) => {
    if (costType.toLowerCase() === "fixed") {
      return (
        <div className="sku-number-type fixed">
          <MotifTooltip
            contentClassName="tooltip-content"
            placement="top"
            hideCloseButton
            flip
            offset={[0, 8]}
            allowHover
            allowClick={true}
            trigger={
              <MotifChip
                className={`sku-badge fixed`}
                onClick={() => {}}
                disabled={false}
              >
                Fixed
              </MotifChip>
            }
            variant="default"
          >
            <div className="label-info-icon-text">{fixedCostInfo()}</div>
          </MotifTooltip>
        </div>
      );
    } else if (costType.toLowerCase() === "variable") {
      return (
        <div className="sku-number-type variable">
          <MotifTooltip
            contentClassName="tooltip-content"
            placement="top"
            hideCloseButton
            flip
            offset={[0, 8]}
            allowHover
            allowClick={true}
            trigger={
              <MotifChip
                className={`sku-badge variable`}
                onClick={() => {}}
                disabled={false}
              >
                Variable
              </MotifChip>
            }
            variant="default"
          >
            <div className="label-info-icon-text">{variableCostInfo()}</div>
          </MotifTooltip>
        </div>
      );
    } else {
      return "";
    }
  };

  const returnOrdersColumns = [
    {
      key: "TransactionReturnId",
      label: renderHeaderWithTooltip("Return ID", returnIdInfo()),
      render: (skuData: ReturnOrderData) => (
        <div className="sku-cell-responsive">
          <div className="sku-name-responsive">
            <MotifTruncate maxLines={1} className="sku-truncate-responsive">
              {String(skuData.TransactionReturnId)}
            </MotifTruncate>
          </div>
          <>
            <div className="view-return">
              <div
                className="view-sku-items"
                onClick={() => {
                  const updatedReturnList = returnList.map((record: any) => ({
                    ...record,
                    isSKUExpanded:
                      skuData.TransactionReturnId === record.TransactionReturnId
                        ? !record.isSKUExpanded
                        : record.isSKUExpanded,
                  }));
                  setReturnList(updatedReturnList);
                }}
              >
                <div>
                  {skuData.isSKUExpanded === true
                    ? "Close Details"
                    : "View Details"}
                </div>
                <div>
                  {skuData.isSKUExpanded === true ? (
                    <MotifIcon iconFunction={IconoirNavArrowUp} size="20" />
                  ) : (
                    <MotifIcon iconFunction={IconoirNavArrowDown} size="20" />
                  )}
                </div>
              </div>
            </div>
          </>
        </div>
      ),
    },
    {
      key: "TransactionReturnRequestedDate",
      label: renderHeaderWithTooltip("Request date", requestedDateInfo()),
      render: (sku: ReturnOrderData) => (
        <div>
          {sku.TransactionReturnRequestedDate != "N/A" ? (
            <>
              {" "}
              <MotifTruncate maxLines={1} maxWidth={200}>
                {getFormattedDate(sku.TransactionReturnRequestedDate)}
              </MotifTruncate>
              <div className="order-id">
                {getFormattedTime(sku.TransactionReturnRequestedDate)}
              </div>
            </>
          ) : (
            <div className="order-id">{sku.TransactionReturnRequestedDate}</div>
          )}
        </div>
      ),
    },
    {
      key: "SKUName",
      label: renderHeaderWithTooltip("SKU", skuIDInfo()),
      render: (sku: ReturnOrderData) => {
        const skuID = sku.SkuId;
        const skuType = sku?.OrderDetails[0]?.SkuDetails.find(
          (item: any) => item.SkuId === skuID,
        )?.SkuType;

        return (
          <div className="sku-name-col">
            <div>
              <MotifTruncate maxLines={1} maxWidth={200}>
                {sku.SkuName}
              </MotifTruncate>
            </div>
            <div className="sku-number suggested-table-content">
              #
              <MotifTruncate
                maxLines={1}
                maxWidth={100}
                tooltipProps={{ placement: "top" }}
              >
                {sku?.SkuId}
              </MotifTruncate>
              {getCostTypeLabel(skuType || "")}
            </div>
          </div>
        );
      },
    },
    {
      key: "OrderName",
      label: renderHeaderWithTooltip("Order", OrderNameInfo()),
      render: (skuData: ReturnOrderData) => (
        <div className="sku-name-responsive">
          <MotifTruncate maxWidth={130}>{skuData.OrderName}</MotifTruncate>
          <div className="order-id">{skuData.OrderParentId}</div>
        </div>
      ),
    },
    {
      key: "UnitUsed",
      label: renderHeaderWithTooltip("Units used", unitUsedInfo()),
      render: (skuData: ReturnOrderData) => (
        <div className="text-right">
          <div>
            {`${formatMetricByQuantity(skuData.UnitsUsed, skuData.Metric)}`}
          </div>
          <div className="secondary-value">
            {`${formatCurrency(Number(skuData.UnitsUsed) * Number(skuData.OrderTransactionUnitCost))}`}
          </div>
        </div>
      ),
    },
    {
      key: "ReturnUsed",
      label: renderHeaderWithTooltip("Return units", returnUnitUsedInfo()),
      render: (skuData: ReturnOrderData) => (
        <div className="text-right">
          <div>
            {`${formatMetricByQuantity(skuData.RequestQuantity, skuData.Metric)}`}
          </div>
          <div className="secondary-value">
            {`${formatCurrency(Number(skuData.RequestQuantity) * Number(skuData.OrderTransactionUnitCost))}`}
          </div>
        </div>
      ),
    },

    {
      key: "ApprovedUsed",
      label: renderHeaderWithTooltip("Approved units", approvedUnitUsedInfo()),
      render: (skuData: ReturnOrderData) => (
        <div className="text-right">
          <div>
            {`${formatMetricByQuantity(skuData.ResponseQuantity, skuData.Metric)}`}
          </div>
          <div className="secondary-value">
            {`${skuData.ResponseQuantity === 0 || skuData.ResponseQuantity === null ? "" : `${formatCurrency(Number(skuData.ResponseQuantity) * Number(skuData.OrderTransactionUnitCost))}`}`}
          </div>
        </div>
      ),
    },
    {
      key: "TransactionStatus",
      label: renderHeaderWithTooltip("Status", returnStatusInfo()),
      render: (order: ReturnOrderData) => {
        return (
          <div className="order-status">
            {getFormattedTransactionStatus(
              order.TransactionStatus,
              order.ResponseReason,
            )}
          </div>
        );
      },
    },
  ];

  const orderAutoTransactColumns = [
    {
      key: "SkuId",
      label: "SKU Name/SKU ID",
      render: (row: any) => (
        <div className="sku-name-responsive">
          <MotifTruncate maxLines={1} className="sku-truncate-responsive">
            {row.SkuName}
          </MotifTruncate>
          <div className="order-id">{row.SkuId}</div>
        </div>
      ),
    },
    {
      key: "ProductName",
      label: "Product Name",
      render: (row: any) => (
        <MotifTruncate maxLines={1} className="sku-truncate-responsive">
          {row.ProductName}
        </MotifTruncate>
      ),
    },
    {
      key: "TransactionId",
      label: (
        <div>
          Transaction ID
          <MotifTooltip
            contentClassName="tooltip-content"
            allowHover
            hideArrow
            trigger={
              <span
                style={{
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <MotifIcon
                  iconFunction={IconoirInfoCircle}
                  size="20"
                  className="motif-tooltip-icon"
                />
              </span>
            }
          >
            <div>
              <strong>{TRANSACTION_ID_TOOLTIP_TITLE}</strong>
              <br />
              New transactions will be marked as <b>
                Pending synchronization
              </b>{" "}
              with Billing Hub. Transactions will be synced every 00:30 UTC and
              changed to <b>Completed</b>.
            </div>
          </MotifTooltip>
        </div>
      ),
      render: (row: any) => {
        let statusColor = "#2DB757"; // Completed
        if (row.TransactionStatus === "Pending") {
          statusColor = "#D07200";
        } else if (row.TransactionStatus === "Failed") {
          statusColor = "#ff4336";
        }
        return (
          <div>
            <MotifTruncate maxLines={1} className="sku-truncate-responsive">
              {row.TransactionID}
            </MotifTruncate>
            <div className="order-id">
              {row.SourceSystem} |{" "}
              <span style={{ color: statusColor, fontWeight: 500 }}>
                {row.TransactionStatus}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      key: "UsagePeriod",
      label: "Usage Period",
      render: (row: any) => {
        const usagePeriod = row.UsagePeriod || "";
        const [startDate, endDate] = usagePeriod.split(" - ");

        return (
          <div>
            {`${startDate}-`}
            {`${endDate}`}
          </div>
        );
      },
    },
    {
      key: "EngagementName",
      label: "Engagement Name/ Engagement Code",
      render: (row: any) => (
        <div className="sku-name-responsive">
          <MotifTruncate maxLines={1} className="sku-truncate-responsive">
            {row.EngagementName}
          </MotifTruncate>
          <div className="order-id">{row.OrderParentEngagementCode}</div>
        </div>
      ),
    },
    {
      key: "CostMetric",
      label: "Cost Metric",
      render: (row: any) => (
        <MotifTruncate maxLines={1} className="sku-truncate-responsive">
          {row.CostMetric}
        </MotifTruncate>
      ),
    },
    {
      key: "UnitCost",
      label: "Unit Cost",
      render: (row: any) => {
        const unitCost = row.UnitCost || "";
        const match = unitCost.match(/^(\$\d+(?:\.\d{1,2})?)\s*(\w+)?$/);
        let amount = unitCost;
        let interval = "";
        if (match) {
          amount = match[1];
          interval = match[2] || "";
        }
        let intervalLabel = "";
        switch (interval.toLowerCase()) {
          case "month":
            intervalLabel = "Monthly";
            break;
          case "week":
            intervalLabel = "Weekly";
            break;
          case "onetime":
            intervalLabel = "One Time";
            break;
          default:
            intervalLabel = interval;
        }
        return (
          <MotifTruncate maxLines={1} className="sku-truncate-responsive">
            {`${amount} ${intervalLabel}`}
          </MotifTruncate>
        );
      },
    },
    {
      key: "Quantity",
      label: "Quantity",
      render: (row: any) => (
        <MotifTruncate maxLines={1} className="sku-truncate-responsive">
          {row.Quantity}
        </MotifTruncate>
      ),
    },
    {
      key: "TotalCost",
      label: "Total Cost",
      render: (row: any) => (
        <div className="order-total">
          {getTotalRecoveriesAmount(row?.TotalCost)}
        </div>
      ),
    },
  ];

  useLayoutEffect(() => {
    const scroller = contentRef.current;
    if (!scroller) return;

    const updateWidth = () => {
      setTrackWidth(scroller.clientWidth);
    };

    // Initial synchronous width
    updateWidth();

    const observer = new ResizeObserver(updateWidth);
    observer.observe(scroller);

    return () => observer.disconnect();
  }, [orders, orderColumns, selectedTab]);

  useLayoutEffect(() => {
    const content = contentRef.current;
    const thumb = thumbRef.current;
    const track = trackRef.current;
    if (!content || !thumb || !track) return;

    const resizeThumb = () => {
      const scrollWidth = content.scrollWidth;
      const clientWidth = content.clientWidth;

      if (scrollWidth <= clientWidth) {
        track.style.display = "none";
        thumb.style.width = "0px";
        return;
      }

      track.style.display = "block";
      const ratio = clientWidth / scrollWidth;
      thumb.style.width = `${clientWidth * ratio}px`;
      thumb.style.left = "0px";
    };

    const checkSticky = () => {
      const rect = content.getBoundingClientRect();
      const viewHeight = window.innerHeight;
      setIsSticky(rect.bottom > viewHeight);
    };

    const handleResize = () => {
      resizeThumb();
      checkSticky();
    };

    // Initial update
    handleResize();

    const observer = new ResizeObserver(handleResize);
    observer.observe(content);

    const mutationObserver = new MutationObserver(handleResize);
    mutationObserver.observe(content, { childList: true, subtree: true });

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", checkSticky);

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", checkSticky);
    };
  }, [orders, orderColumns, selectedTab]);

  useEffect(() => {
    const content = contentRef.current || null;
    const thumb = thumbRef.current;
    const track = trackRef.current;
    if (!content || !thumb || !track) return;

    const syncThumbToTable = () => {
      const scrollWidth = content.scrollWidth;
      const clientWidth = content.clientWidth;

      if (scrollWidth <= clientWidth) {
        thumb.style.width = "0";
        return;
      }

      const ratio = clientWidth / scrollWidth;
      thumb.style.width = `${clientWidth * ratio}px`;

      const scrollPercent = content.scrollLeft / (scrollWidth - clientWidth);

      const maxLeft = track.offsetWidth - thumb.offsetWidth;
      thumb.style.left = `${scrollPercent * maxLeft}px`;
    };

    content.addEventListener("scroll", syncThumbToTable);
    syncThumbToTable();

    return () => content.removeEventListener("scroll", syncThumbToTable);
  }, [orders, orderColumns, selectedTab, trackWidth]);

  useEffect(() => {
    const content = contentRef.current;
    const thumb = thumbRef.current;
    const track = trackRef.current;

    if (!content || !thumb || !track) return;

    let isDragging = false;
    let startX = 0;
    let startLeft = 0;

    const onMouseDown = (e: MouseEvent) => {
      isDragging = true;
      startX = e.clientX;
      startLeft = parseFloat(thumb.style.left || "0");
      thumb.style.cursor = "grabbing";
      e.preventDefault();
    };

    const onMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;

      const dx = e.clientX - startX;
      let newLeft = startLeft + dx;

      const maxLeft = track.offsetWidth - thumb.offsetWidth;
      newLeft = Math.max(0, Math.min(newLeft, maxLeft));

      thumb.style.left = `${newLeft}px`;
      const scrollPercent = maxLeft === 0 ? 0 : newLeft / maxLeft;
      content.scrollLeft =
        scrollPercent * (content.scrollWidth - content.clientWidth);
    };

    const onMouseUp = () => {
      isDragging = false;
      thumb.style.cursor = "grab";
    };

    thumb.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);

    return () => {
      thumb.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [selectedTab, trackWidth, thumbRef.current?.offsetWidth, orders]);

  return (
    <div className="home-orderpipeline-section">
      <div className="toast-container">
        {toastSuccess && (
          <MotifToast
            onClose={toastCloseHandler}
            variant="success"
            position={
              toastSuccessMessage === "SKU completion complete" ||
              toastSuccessMessage === "SKU provision marked in progress"
                ? "top"
                : "bottom"
            }
          >
            <div slot="toast-supporting-text">{toastSuccessMessage}</div>
          </MotifToast>
        )}
      </div>
      <ApproveModal
        show={showApproveSkuModal}
        setShow={setShowApproveSkuModal}
        btnLabel="Approve"
        approveHandler={approveSKU}
      />
      {showProvisioningModal && selectedSkuData && (
        <SkuProvisionModal
          show={showProvisioningModal}
          provisionStatus={tempProvisionStatus}
          selectedSkuData={selectedSkuData}
          saveStatus={saveStatus}
          dateHandler={dateHandler}
          cancelHandler={() => {
            loadOrderTab();
            setShowProvisioningModal(false);
          }}
        />
      )}

      {/* return reject modal */}
      <RejectModal
        show={showRejectSkuModal}
        setShow={setShowRejectSkuModal}
        btnLabel="Reject SKU"
        rejectMessage="Please provide a reason for rejecting this SKU:"
        rejectHandler={(rejectMsg) => rejectSKU(rejectMsg)}
        apiErrorMessage={rejectReasonApiError}
        onClearApiError={() => setRejectReasonApiError("")}
      />

      <CancelModal
        show={showCancelOrderModal}
        setShow={setShowCancelOrderModal}
        cancelHandler={handleCancelOrder}
        isCancelLoading={isCancelOrderLoading}
      />
      <ReturnOrderModal
        show={showReturnOrderModal}
        setShow={setShowReturnOrderModal}
        skuDetails={selectedSkuData as OrderData}
        handleOrderReturnSuccess={handleOrderReturnSuccess}
      />

      <section className="orderpipeline-container">
        <div className="orderpipeline-tab-container">
          <MotifTabNavigation
            defaultActiveKey={0}
            orientation="horizontal"
            size="md"
            variant="default"
            controlled={true}
          >
            <MotifTabControl
              className={selectedTab === 0 ? "motif-active" : ""}
              onClick={() => onTabChange("estimates")}
            >
              Estimates
              {selectedTab === 0 ? (
                <MotifBadge variant={"info"} value={totalEstimateRecords} />
              ) : null}
            </MotifTabControl>
            <MotifTabControl
              className={selectedTab === 1 ? "motif-active" : ""}
              onClick={() => onTabChange("orders")}
            >
              Orders
              {selectedTab === 1 ? (
                <MotifBadge variant={"info"} value={totalOrdersRecords} />
              ) : null}
            </MotifTabControl>
            <MotifTabControl
              className={selectedTab === 2 ? "motif-active" : ""}
              onClick={() => onTabChange("approvals")}
            >
              {APPROVALS}
              {selectedTab === 2 ? (
                <MotifBadge variant={"info"} value={totalApprovalsRecords} />
              ) : null}
            </MotifTabControl>

            <MotifTabControl
              className={selectedTab === 3 ? "motif-active" : ""}
              onClick={() => onTabChange("cancelled-orders")}
            >
              {CANCELLED_ORDERS}
              {selectedTab === 3 ? (
                <MotifBadge
                  variant={"info"}
                  value={totalCancelledOrdersRecords}
                />
              ) : null}
            </MotifTabControl>
            <MotifTabControl
              className={selectedTab === 4 ? "motif-active" : ""}
              onClick={() => onTabChange("returns")}
            >
              {RETURNS}
              {selectedTab === 4 ? (
                <MotifBadge variant={"info"} value={totalReturnRecords} />
              ) : null}
            </MotifTabControl>
            <MotifTabControl
              className={selectedTab === 5 ? "motif-active" : ""}
              onClick={() => onTabChange("recoveries")}
            >
              Recoveries
              {selectedTab === 5 ? (
                <MotifBadge variant={"info"} value={totalRecoveriesRecords} />
              ) : null}
            </MotifTabControl>
            <MotifTabControl
              className={selectedTab === 6 ? "motif-active" : ""}
              onClick={() => onTabChange("auto-transact")}
            >
              {TRANSACTIONS}
              {selectedTab === 6 ? (
                <MotifBadge variant={"info"} value={totalAutoTransactRecords} />
              ) : null}
            </MotifTabControl>
          </MotifTabNavigation>
          <div className="order-pipeline-search-container">
            <MotifButton
              aria-label="filter"
              id="dropdown-trigger-1"
              className="order-pipeline-filter"
              onClick={toggleDropdown}
            >
              Filter
              <MotifIcon
                size={"20"}
                iconFunction={IconoirFilterList}
                className="motif-filter-icon"
              />
            </MotifButton>
          </div>
          <div className="search-input-container">
            <SearchInput
              id={"order-bundle-search-details"}
              aria-label={"Search"}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                removeOrderPipelineQueryParams();
                const isContainEmoji = containsEmoji(event.target.value);
                if (isContainEmoji) {
                  setSearchValidationError(EMOJI_ERROR_MESSAGE);
                } else {
                  setSearchValidationError("");
                }
                setSearchValue(event.target.value);
                if (event.target.value === "") {
                  handleSearch("");
                }
                resetPagination();
              }}
              clearSearch={() => {
                setSearchValidationError("");
                handleSearch("");
              }}
              onEnter={(e: React.KeyboardEvent<HTMLInputElement>) => {
                const isContainEmoji = containsEmoji(e.currentTarget.value);
                if (!isContainEmoji) {
                  handleSearch(e.currentTarget.value);
                }
              }}
              placeholder={"Search"}
              value={searchValue}
              className="orderpipeline-product-search"
            />
            {searchValidationError && (
              <MotifErrorMessage className="search-helper-text">
                {searchValidationError}
              </MotifErrorMessage>
            )}
          </div>
        </div>
        <div className="orderPipeline-orders-section-wrapper">
          {isToggleOpen && selectedTab === 0 && (
            <div className="filter-dropdown">
              <div className="status-dropdown">
                <span>Order Status</span>
                <MotifSelect
                  onChange={(statusCol) =>
                    handleOrderStatusChange(String(statusCol))
                  }
                  value={orderStatus}
                  visibleOptions={5}
                  filter={orderStatus !== orderStatusOptions[0].value}
                  onClear={() => handleOrderStatusChange("all")}
                >
                  {orderStatusOptions.map((option) => (
                    <MotifOption key={option.value} value={option.value}>
                      {option.label}
                    </MotifOption>
                  ))}
                </MotifSelect>
              </div>
              <div className="range-picker">
                <span>Date Range</span>
                <MotifDatePicker
                  clearIcon={null}
                  dayPlaceholder="DD"
                  range={true}
                  format="dd/MM/yyyy"
                  maxDate={new Date(NaN)}
                  minDate={new Date(NaN)}
                  monthPlaceholder="MM"
                  onCalendarClose={() => {}}
                  onCalendarOpen={() => {}}
                  onChange={handleDateChange}
                  value={dateRange}
                  yearPlaceholder="YYYY"
                />
              </div>
              <div className="clear-btn">
                <MotifButton
                  type="button"
                  variant="text"
                  disabled={isClearEstimateBtnDisabled}
                  onClick={clearFilter}
                >
                  Clear
                </MotifButton>
              </div>
            </div>
          )}
          {isToggleOpen && selectedTab === 1 && (
            <div className="filter-dropdown">
              <div className="status-dropdown">
                <span>Provisioning Status</span>
                <MultiSelect
                  options={provStatusOptionsInOrders}
                  value={selectedProvStatusInOrder}
                  onChange={(selected: any) => {
                    handleProvisioningStatusChange(selected);
                  }}
                  placeholder="All"
                  hasSelectAll={true}
                  selectAllLabel="Select all"
                  selectAllValue="all"
                />
              </div>
              <div className="range-picker">
                <span>Date Range</span>
                <MotifDatePicker
                  clearIcon={null}
                  dayPlaceholder="DD"
                  range={true}
                  format="dd/MM/yyyy"
                  maxDate={new Date(NaN)}
                  minDate={new Date(NaN)}
                  monthPlaceholder="MM"
                  onCalendarClose={() => {}}
                  onCalendarOpen={() => {}}
                  onChange={handleDateChange}
                  value={dateRange}
                  yearPlaceholder="YYYY"
                  disabled={isOrdersLoading}
                />
              </div>
              <div className="clear-btn">
                <MotifButton
                  type="button"
                  variant="text"
                  disabled={isClearOrderBtnDisabled}
                  onClick={clearFilter}
                >
                  Clear
                </MotifButton>
              </div>
            </div>
          )}
          {isToggleOpen && selectedTab === 3 && (
            <div className="filter-dropdown">
              <div className="range-picker">
                <span>Date Range</span>
                <MotifDatePicker
                  clearIcon={null}
                  dayPlaceholder="DD"
                  range={true}
                  format="dd/MM/yyyy"
                  maxDate={new Date(NaN)}
                  minDate={new Date(NaN)}
                  monthPlaceholder="MM"
                  onCalendarClose={() => {}}
                  onCalendarOpen={() => {}}
                  onChange={handleDateChange}
                  value={dateRange}
                  yearPlaceholder="YYYY"
                />
              </div>
              <div className="clear-btn">
                <MotifButton
                  type="button"
                  variant="text"
                  disabled={isClearCancelledBtnDisabled}
                  onClick={clearFilter}
                >
                  Clear
                </MotifButton>
              </div>
            </div>
          )}

          {isToggleOpen && selectedTab === 2 && (
            <div className="filter-dropdown">
              <div className="range-picker">
                <span>Date Range</span>
                <MotifDatePicker
                  clearIcon={null}
                  dayPlaceholder="DD"
                  range={true}
                  format="dd/MM/yyyy"
                  maxDate={new Date(NaN)}
                  minDate={new Date(NaN)}
                  monthPlaceholder="MM"
                  onCalendarClose={() => {}}
                  onCalendarOpen={() => {}}
                  onChange={handleDateChange}
                  value={dateRange}
                  yearPlaceholder="YYYY"
                />
              </div>
              <div className="clear-btn">
                <MotifButton
                  type="button"
                  variant="text"
                  disabled={isClearApprovalBtnDisabled}
                  onClick={clearFilter}
                >
                  Clear
                </MotifButton>
              </div>{" "}
            </div>
          )}
          {isToggleOpen && selectedTab === 4 && (
            <div className="filter-dropdown">
              <div className="status-returnTab-dropdown">
                <span>Status</span>
                <MultiSelect
                  options={returnStatusOptions}
                  value={selectedReturnStatus}
                  onChange={(selected: any) => {
                    removeOrderPipelineQueryParams();
                    setSelectedReturnStatus(selected);
                    setIsClearReturnBtnDisabled(false);

                    if (returnsFilterTimerRef.current) {
                      clearTimeout(returnsFilterTimerRef.current);
                    }

                    returnsFilterTimerRef.current = setTimeout(() => {
                      setPaginationForReturn((prev: any) => ({
                        ...prev,
                        Status: selected.filter(
                          (item: string) => item !== "all",
                        ),
                        Type:
                          selectedReturnType.length == 3
                            ? []
                            : selectedReturnType,
                        currentPage: 1,
                      }));
                      returnsFilterTimerRef.current = null;
                    }, 500);
                  }}
                  placeholder="All"
                  hasSelectAll={true}
                  selectAllLabel="Select all"
                  selectAllValue="all"
                />
              </div>
              <div className="status-returnTab-dropdown">
                <span>Type</span>
                <MultiSelect
                  options={returnTypeOptions}
                  value={selectedReturnType}
                  onChange={(selected: any) => {
                    removeOrderPipelineQueryParams();
                    setSelectedReturnType(selected);
                    setIsClearReturnBtnDisabled(false);

                    if (returnsFilterTimerRef.current) {
                      clearTimeout(returnsFilterTimerRef.current);
                    }

                    returnsFilterTimerRef.current = setTimeout(() => {
                      setPaginationForReturn((prev: any) => ({
                        ...prev,
                        Status: selectedReturnStatus.filter(
                          (item: string) => item !== "all",
                        ),
                        Type: selected.length == 3 ? [] : selected,
                        currentPage: 1,
                      }));
                      returnsFilterTimerRef.current = null;
                    }, 500);
                  }}
                  placeholder="All"
                  hasSelectAll={true}
                  selectAllLabel="Select all"
                  selectAllValue="all"
                />
              </div>
              <div className="status-returnTab-dropdown">
                <span>Requested Date</span>
                <MotifSelect
                  onChange={(type) =>
                    handleReturnRequestedDateChange(type as string)
                  }
                  value={selectedReturnRequestedDate}
                  filter={
                    selectedReturnRequestedDate !==
                    returnRequestedDateOptions[0].value
                  }
                  onClear={() => handleReturnRequestedDateChange()}
                  visibleOptions={5}
                >
                  {returnRequestedDateOptions.map((option) => (
                    <MotifOption key={option.value} value={option.value}>
                      {option.label}
                    </MotifOption>
                  ))}
                </MotifSelect>
              </div>
              <div className="clear-btn">
                <MotifButton
                  type="button"
                  variant="text"
                  disabled={isClearReturnBtnDisabled}
                  onClick={clearFilter}
                >
                  Clear
                </MotifButton>
              </div>
            </div>
          )}

          {isToggleOpen && selectedTab === 5 && (
            <div className="filter-dropdown">
              <div className="recoveries-status-dropdown">
                <span>Billing Type</span>
                <MotifSelect
                  onChange={(type) => handleBillingTypeChange(type as string)}
                  value={billingType}
                  visibleOptions={5}
                  filter={billingType !== billingTypeOptions[0].value}
                  onClear={() =>
                    handleBillingTypeChange(billingTypeOptions[0].value)
                  }
                >
                  {billingTypeOptions.map((option) => (
                    <MotifOption key={option.value} value={option.value}>
                      {option.label}
                    </MotifOption>
                  ))}
                </MotifSelect>
              </div>
              {/* <div className="range-picker">
                <span>Date Range</span>
                <MotifDatePicker
                  clearIcon={null}
                  dayPlaceholder="DD"
                  range={true}
                  format="dd/MM/yyyy"
                  maxDate={new Date(NaN)}
                  minDate={new Date(NaN)}
                  monthPlaceholder="MM"
                  onCalendarClose={() => { }}
                  onCalendarOpen={() => { }}
                  onChange={handleDateChange}
                  value={dateRange}
                  yearPlaceholder="YYYY"
                />
              </div> */}
              <div className="status-dropdown">
                <span>Transaction Date</span>
                <MotifSelect
                  onChange={(transaction) =>
                    handleTransactionDateChange(transaction as string)
                  }
                  value={transactionDate}
                  visibleOptions={5}
                  filter={transactionDate !== requestDateOptions[0].value}
                  onClear={() =>
                    handleTransactionDateChange(requestDateOptions[0].value)
                  }
                >
                  {requestDateOptions.map((option) => (
                    <MotifOption key={option.value} value={option.value}>
                      {option.label}
                    </MotifOption>
                  ))}
                </MotifSelect>
              </div>
              <div className="clear-btn">
                <MotifButton
                  type="button"
                  variant="text"
                  disabled={isClearRecoveriesBtnDisabled}
                  onClick={clearFilter}
                >
                  Clear
                </MotifButton>
              </div>
            </div>
          )}

          {/* {isToggleOpen && selectedTab === 6 && (
            <div className="filter-dropdown">
              <div className="status-dropdown">
                <span>SKU Name</span>
                <MotifSelect
                  onChange={(skuName) => handleSkuNameChange(String(skuName))}
                  value={selectedSkuName}
                  visibleOptions={5}
                >
                  {skuNameOptions.map((option) => (
                    <MotifOption key={option.value} value={option.value}>
                      {option.label}
                    </MotifOption>
                  ))}
                </MotifSelect>
              </div>
              <div className="status-dropdown">
                <span>Product</span>
                <MotifSelect
                  onChange={(product) => handleProductChange(String(product))}
                  value={selectedProductName}
                  visibleOptions={5}
                >
                  {productOptions.map((option) => (
                    <MotifOption key={option.value} value={option.value}>
                      {option.label}
                    </MotifOption>
                  ))}
                </MotifSelect>
              </div>
              <div className="status-dropdown">
                <span>Transaction Status</span>
                <MotifSelect
                  onChange={(status) =>
                    handleTransactionStatusChange(String(status))
                  }
                  value={selectedTransactionStatus}
                  visibleOptions={5}
                >
                  {transactionOptions.map((option) => (
                    <MotifOption key={option.value} value={option.value}>
                      {option.label}
                    </MotifOption>
                  ))}
                </MotifSelect>
              </div>
              <div className="range-picker">
                <span>Date Range</span>
                <MotifDatePicker
                  clearIcon={null}
                  dayPlaceholder="DD"
                  range={true}
                  format="dd/MM/yyyy"
                  maxDate={new Date(NaN)}
                  minDate={new Date(NaN)}
                  monthPlaceholder="MM"
                  onCalendarClose={() => { }}
                  onCalendarOpen={() => { }}
                  onChange={handleDateChange}
                  value={dateRange}
                  yearPlaceholder="YYYY"
                />
              </div>
              <div className="clear-btn">
                <MotifButton
                  type="button"
                  variant="text"
                  disabled={isClearAutoTransactBtnDisabled}
                  onClick={clearFilter}
                >
                  Clear
                </MotifButton>
              </div>
            </div>
          )} */}

          {selectedTab === 0 && (
            <div className="orderPipeline-estimates-section">
              <div className="orderPipeline-orders-list">
                <div className="orderPipeline-orders-header">
                  <div className="motif-row">
                    <div className="motif-col-lg-9">
                      <h3 className="orderPipeline-orders-title">{ESTIMATE}</h3>
                    </div>
                    {
                      <div className="motif-col-lg-3 create-new-estimate">
                        <MotifButton
                          className="create-new-estimate-button"
                          onClick={() => navigate("/marketplace")}
                        >
                          New Estimate
                          <MotifIcon
                            iconFunction={IconoirPlus}
                            fill="#fff"
                            stroke="#fff"
                          />
                        </MotifButton>
                      </div>
                    }
                  </div>
                </div>
                <div className="orderPipeline-orders-content">
                  {isEstimateLoading && (
                    <MotifProgressLoader
                      aria-busy="true"
                      aria-label="This page is loading"
                      aria-live="polite"
                      arialabel="This page is loading"
                      show
                      variant="default"
                      className="home-orderpipeline-progress"
                    />
                  )}
                  {!isEstimateLoading && isEstimateError && (
                    <>
                      <ErrorOrderPage
                        image={productListEmptyImg}
                        header="An error has occurred while attempting to retrieve data. Please choose the option to refresh the page."
                        handleRefresh={() => {
                          setIsEstimateError(false);
                          setPaginationEstimateObj((prev: any) => ({
                            ...prev,
                          }));
                        }}
                      />
                    </>
                  )}

                  {!isEstimateLoading &&
                    !isEstimateError &&
                    ordersEstimate.length >= 0 && (
                      <OrdersEstimateTable
                        data={ordersEstimate}
                        setOrdersEstimate={setOrdersEstimate}
                        columnsData={orderEstimateColumns}
                        setShowPagination={setShowEstimatePagination}
                        searchText={debouncedSearchValue}
                        status={orderStatus}
                        isFilterApplied={!isClearEstimateBtnDisabled}
                      />
                    )}
                </div>
                {!isEstimateLoading &&
                  !isEstimateError &&
                  ordersEstimate.length >= 0 && (
                    <div
                      className={`pagination-grid ${
                        showEstimatePagination ? "" : "hide"
                      }`}
                    >
                      <CustomPagination
                        currentpage={paginationEstimateObj.currentPage}
                        pageSize={paginationEstimateObj.pageSize}
                        disableNext={false}
                        onChangePageSize={(page: number) => {
                          setPaginationEstimateObj({
                            ...paginationEstimateObj,
                            pageSize: Number(page),
                            currentPage: 1,
                          });
                        }}
                        onChangeNextPage={() => {
                          setPaginationEstimateObj({
                            ...paginationEstimateObj,
                            currentPage: paginationEstimateObj.currentPage + 1,
                          });
                        }}
                        onChangeFirstPage={() => {
                          setPaginationEstimateObj({
                            ...paginationEstimateObj,
                            currentPage: 1,
                          });
                        }}
                        onChangePreviousPage={() => {
                          setPaginationEstimateObj({
                            ...paginationEstimateObj,
                            currentPage: paginationEstimateObj.currentPage - 1,
                          });
                        }}
                        onChangeLastPage={() => {
                          setPaginationEstimateObj({
                            ...paginationEstimateObj,
                            currentPage: totalEstimatePages || 0,
                          });
                        }}
                        pageSizeSelector={[10, 20, 50]}
                        totalRecords={totalEstimateRecords || 0}
                      />
                    </div>
                  )}
              </div>
            </div>
          )}

          {selectedTab === 1 && (
            <div className="orderPipeline-orders-section">
              {emailNotification && emailNotification.show && (
                <div className="orderPipeline-orders-notification">
                  <div className="motif-row mar-b-20">
                    <div className="motif-col-lg-12">
                      <EmailNotification
                        show={emailNotification.show}
                        message={emailNotification.message}
                        supportingText={emailNotification.supportingText}
                        type={emailNotification.type}
                        actionRedirectUrl={emailNotification.actionRedirectUrl}
                        hideCloseBtn={true}
                        actionRedirectLabel={
                          emailNotification.actionRedirectLabel
                        }
                        theme="dark"
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="orderPipeline-orders-list">
                <div className="orderPipeline-orders-header">
                  <div className="motif-row">
                    <div className="motif-col-lg-9">
                      <h3 className="orderPipeline-orders-title">{ORDER}</h3>
                    </div>
                    {orders && orders.length > 0 && (
                      <div className="motif-col-lg-3 create-new-estimate">
                        <MotifButton
                          className="create-new-estimate-button"
                          onClick={() =>
                            downloadOrderCsvFile(debouncedSearchValue)
                          }
                          variant="secondary"
                          disabled={isCSVLoading}
                        >
                          Export{" "}
                          <MotifIcon
                            iconFunction={IconoirCustomExport}
                            fill="#fff"
                            stroke="#fff"
                          />
                        </MotifButton>
                      </div>
                    )}
                  </div>
                </div>
                {!isOrdersLoading &&
                  !isOrdersError &&
                  orders.length > 0 &&
                  statusLegend()}
                <div className="orderPipeline-orders-content">
                  {isOrdersLoading && (
                    <MotifProgressLoader
                      aria-busy="true"
                      aria-label="This page is loading"
                      aria-live="polite"
                      arialabel="This page is loading"
                      show
                      variant="default"
                      className="home-orderpipeline-progress"
                    />
                  )}
                  {!isOrdersLoading && isOrdersError && (
                    <>
                      <ErrorOrderPage
                        image={productListEmptyImg}
                        header="An error has occurred while attempting to retrieve data. Please choose the option to refresh the page."
                        handleRefresh={() => {
                          setIsOrdersError(false);
                          setPaginationOrdersObj((prev: any) => ({ ...prev }));
                        }}
                      />
                    </>
                  )}

                  {!isOrdersLoading && !isOrdersError && orders.length >= 0 && (
                    <>
                      <div
                        className="orders-scroll-wrapper"
                        ref={scrollWrapperRef}
                      >
                        <div
                          className="orders-scroll-content"
                          ref={contentRef}
                          style={{
                            minHeight:
                              orders.length > 6
                                ? "auto"
                                : orders.length * 101 + 460 + "px",
                          }}
                        >
                          <OrdersTable
                            data={orders}
                            columnsData={orderColumns}
                            setOrders={setOrders}
                            setShowPagination={setShowOrdersPagination}
                            searchText={debouncedSearchValue}
                            isFilterApplied={!isClearOrderBtnDisabled}
                          />
                        </div>
                      </div>
                      {(exportErrorMessage || exportSuccessMessage) && (
                        <Toast
                          variantType={exportErrorMessage ? "error" : "success"}
                          message={exportErrorMessage || exportSuccessMessage}
                          timer={3000}
                        />
                      )}
                    </>
                  )}
                </div>
                {!isOrdersLoading && !isOrdersError && orders.length > 0 && (
                  <div
                    className={`orders-h-scroll-track ${
                      isSticky ? "sticky-bar" : ""
                    }`}
                    ref={trackRef}
                    style={{
                      width: trackWidth + "px",
                      left:
                        isSticky && contentRef.current
                          ? contentRef.current.getBoundingClientRect().left +
                            "px"
                          : "auto",
                    }}
                  >
                    <div className="orders-h-scroll-thumb" ref={thumbRef}></div>
                  </div>
                )}

                {!isOrdersLoading && !isOrdersError && orders.length >= 0 && (
                  <div
                    className={`pagination-grid ${
                      showOrdersPagination ? "" : "hide"
                    }`}
                  >
                    <div>
                      <CustomPagination
                        currentpage={paginationOrdersObj.currentPage}
                        pageSize={paginationOrdersObj.pageSize}
                        disableNext={false}
                        onChangePageSize={(page: number) => {
                          setPaginationOrdersObj({
                            ...paginationOrdersObj,
                            pageSize: Number(page),
                            currentPage: 1,
                          });
                        }}
                        onChangeNextPage={() => {
                          setPaginationOrdersObj({
                            ...paginationOrdersObj,
                            currentPage: paginationOrdersObj.currentPage + 1,
                          });
                        }}
                        onChangeFirstPage={() => {
                          setPaginationOrdersObj({
                            ...paginationOrdersObj,
                            currentPage: 1,
                          });
                        }}
                        onChangePreviousPage={() => {
                          setPaginationOrdersObj({
                            ...paginationOrdersObj,
                            currentPage: paginationOrdersObj.currentPage - 1,
                          });
                        }}
                        onChangeLastPage={() => {
                          setPaginationOrdersObj({
                            ...paginationOrdersObj,
                            currentPage: totalOrdersPages || 0,
                          });
                        }}
                        pageSizeSelector={[10, 20, 50]}
                        totalRecords={totalOrdersRecords || 0}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {selectedTab === 2 && (
            <div className="orderPipeline-approval-section">
              {emailNotification && emailNotification.show && (
                <div className="orderPipeline-orders-notification">
                  <div className="motif-row mar-b-20">
                    <div className="motif-col-lg-12">
                      <EmailNotification
                        show={emailNotification.show}
                        message={emailNotification.message}
                        supportingText={emailNotification.supportingText}
                        type={emailNotification.type}
                        hideCloseBtn={true}
                        theme="dark"
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="orderPipeline-orders-list">
                <div className="orderPipeline-orders-header">
                  <h3 className="orderPipeline-orders-title">{APPROVALS}</h3>
                </div>
                {!isLoading &&
                  !isApprovalListApiError &&
                  approvalList.length > 0 &&
                  statusLegend()}
                <div className="orderPipeline-orders-content">
                  {isLoading && (
                    <div className="table-loader">
                      <MotifProgressLoader
                        aria-busy="true"
                        aria-label="This page is loading"
                        aria-live="polite"
                        arialabel="This page is loading"
                        show
                        variant="default"
                        className="home-orderpipeline-progress"
                      />
                    </div>
                  )}
                  {!isLoading && isApprovalListApiError && (
                    <>
                      <ErrorOrderPage
                        image={productListEmptyImg}
                        header="An error has occurred while attempting to retrieve data. Please choose the option to refresh the page."
                        handleRefresh={() => {
                          setIsApprovalListApiError(false);
                          setPaginationForApproval((prev: any) => ({
                            ...prev,
                          }));
                        }}
                      />
                    </>
                  )}

                  {!isLoading &&
                    !isApprovalListApiError &&
                    approvalList.length >= 0 && (
                      <ApprovalsTable
                        data={approvalList}
                        columnsData={approvalTableColumns}
                        setOrders={setApprovalList}
                        setShowPagination={setShowApprovalPagination}
                        searchText={debouncedSearchValue}
                        isFilterApplied={!isClearApprovalBtnDisabled}
                      />
                    )}
                </div>
                {!isLoading &&
                  !isApprovalListApiError &&
                  approvalList.length >= 0 && (
                    <div
                      className={`pagination-grid ${
                        showApprovalPagination ? "" : "hide"
                      }`}
                    >
                      <CustomPagination
                        currentpage={paginationForApprovals.currentPage}
                        pageSize={paginationForApprovals.pageSize}
                        disableNext={false}
                        onChangePageSize={(page: number) => {
                          setPaginationForApproval({
                            ...paginationForApprovals,
                            pageSize: Number(page),
                            currentPage: 1,
                          });
                        }}
                        onChangeNextPage={() => {
                          setPaginationForApproval({
                            ...paginationForApprovals,
                            currentPage: paginationForApprovals.currentPage + 1,
                          });
                        }}
                        onChangeFirstPage={() => {
                          setPaginationForApproval({
                            ...paginationForApprovals,
                            currentPage: 1,
                          });
                        }}
                        onChangePreviousPage={() => {
                          setPaginationForApproval({
                            ...paginationForApprovals,
                            currentPage: paginationForApprovals.currentPage - 1,
                          });
                        }}
                        onChangeLastPage={() => {
                          setPaginationForApproval({
                            ...paginationForApprovals,
                            currentPage: totalApprovalsPages || 0,
                          });
                        }}
                        pageSizeSelector={[10, 20, 50]}
                        totalRecords={totalApprovalsRecords || 0}
                      />
                    </div>
                  )}
              </div>
            </div>
          )}

          {selectedTab === 5 && (
            <div className="orderPipeline-estimates-section">
              <div className="orderPipeline-orders-list">
                <div className="orderPipeline-orders-header">
                  <div className="motif-row">
                    <div className="motif-col-lg-9">
                      <h3 className="orderPipeline-orders-title">
                        {RECOVERIES}
                      </h3>
                      {ordersRecoveries && ordersRecoveries.length > 0 && (
                        <p className="margin-0">
                          {TOTAL_BILLED} :{" "}
                          <span className="order-total">
                            {getTotalRecoveriesAmount(totalBilledInRecoveries)}
                          </span>
                        </p>
                      )}
                    </div>
                    {ordersRecoveries && ordersRecoveries.length > 0 && (
                      <div className="motif-col-lg-3 create-new-estimate">
                        <MotifButton
                          className="create-new-estimate-button"
                          onClick={() => setSelectedTabHome(0)}
                        >
                          Export{" "}
                          <MotifIcon
                            iconFunction={IconoirCustomExport}
                            fill="#fff"
                            stroke="#fff"
                          />
                        </MotifButton>
                      </div>
                    )}
                  </div>
                </div>
                <div className="orderPipeline-orders-content">
                  {isRecoveriesLoading && (
                    <MotifProgressLoader
                      aria-busy="true"
                      aria-label="This page is loading"
                      aria-live="polite"
                      arialabel="This page is loading"
                      show
                      variant="default"
                      className="home-orderpipeline-progress"
                    />
                  )}
                  {!isRecoveriesLoading && isRecoveriesError && (
                    <ErrorOrderPage
                      image={productListEmptyImg}
                      header="An error has occurred while attempting to retrieve data. Please choose the option to refresh the page."
                      handleRefresh={() => {
                        setIsRecoveriesError(false);
                        setPaginationRecoveriesObj((prev: any) => ({
                          ...prev,
                        }));
                      }}
                    />
                  )}

                  {!isRecoveriesLoading &&
                    !isRecoveriesError &&
                    ordersRecoveries &&
                    ordersRecoveries.length >= 0 && (
                      <OrdersRecoveryTable
                        data={ordersRecoveries}
                        setOrdersRecoveries={setOrdersRecoveries}
                        columnsData={orderRecoveryColumns}
                        setShowPagination={setShowRecoveriesPagination}
                        searchText={debouncedSearchValue}
                        isLoading={isRecoveriesLoading}
                        billingType={billingType}
                        transactionDate={transactionDate}
                        isFilterApplied={!isClearRecoveriesBtnDisabled}
                        recoveryDetailsErrorMap={recoveryDetailsErrorMap}
                        isRecoveriesDetailsLoading={isRecoveriesDetailsLoading}
                        isRecoveriesDetailsError={isRecoveriesDetailsError}
                        handleRecoveryRowExpand={handleRecoveryRowExpand}
                      />
                    )}
                </div>
                {!isRecoveriesLoading &&
                  !isRecoveriesError &&
                  ordersRecoveries &&
                  ordersRecoveries.length >= 0 && (
                    <div
                      className={`pagination-grid ${
                        showRecoveriesPagination ? "" : "hide"
                      }`}
                    >
                      <CustomPagination
                        currentpage={paginationRecoveriesObj.currentPage}
                        pageSize={paginationRecoveriesObj.pageSize}
                        disableNext={false}
                        onChangePageSize={(page: number) => {
                          setPaginationRecoveriesObj({
                            ...paginationRecoveriesObj,
                            pageSize: Number(page),
                            currentPage: 1,
                          });
                        }}
                        onChangeNextPage={() => {
                          setPaginationRecoveriesObj({
                            ...paginationRecoveriesObj,
                            currentPage:
                              paginationRecoveriesObj.currentPage + 1,
                          });
                        }}
                        onChangeFirstPage={() => {
                          setPaginationRecoveriesObj({
                            ...paginationRecoveriesObj,
                            currentPage: 1,
                          });
                        }}
                        onChangePreviousPage={() => {
                          setPaginationRecoveriesObj({
                            ...paginationRecoveriesObj,
                            currentPage:
                              paginationRecoveriesObj.currentPage - 1,
                          });
                        }}
                        onChangeLastPage={() => {
                          setPaginationRecoveriesObj({
                            ...paginationRecoveriesObj,
                            currentPage: totalRecoveriesPages || 0,
                          });
                        }}
                        pageSizeSelector={[10, 20, 50]}
                        totalRecords={totalRecoveriesRecords || 0}
                      />
                    </div>
                  )}
              </div>
            </div>
          )}

          {selectedTab === 3 && (
            <div className="orderPipeline-cancelledOrder-section">
              <div className="orderPipeline-orders-list">
                <div className="orderPipeline-orders-header">
                  <h3 className="orderPipeline-orders-title">
                    {CANCELLED_ORDERS}
                  </h3>
                </div>
                <div className="orderPipeline-orders-content">
                  {isCancelledOrdersLoading && (
                    <MotifProgressLoader
                      aria-busy="true"
                      aria-label="This page is loading"
                      aria-live="polite"
                      arialabel="This page is loading"
                      show
                      variant="default"
                      className="home-orderpipeline-progress"
                    />
                  )}
                  {!isCancelledOrdersLoading && isCancelledOrdersError && (
                    <>
                      <ErrorOrderPage
                        image={productListEmptyImg}
                        header="An error has occurred while attempting to retrieve data. Please choose the option to refresh the page."
                        handleRefresh={() => {
                          setIsCancelledOrdersError(false);
                          setPaginationCancelledOrdersObj((prev: any) => ({
                            ...prev,
                          }));
                        }}
                      />
                    </>
                  )}

                  {!isCancelledOrdersLoading &&
                    !isCancelledOrdersError &&
                    cancelledOrders.length >= 0 && (
                      <CancelledOrdersTable
                        data={cancelledOrders}
                        columnsData={cancelledOrderColumns}
                        setOrders={setCancelledOrders}
                        setShowPagination={setShowCancelledOrdersPagination}
                        searchText={debouncedSearchValue}
                        isFilterApplied={!isClearCancelledBtnDisabled}
                      />
                    )}
                </div>
                {!isCancelledOrdersLoading &&
                  !isCancelledOrdersError &&
                  cancelledOrders.length >= 0 && (
                    <div
                      className={`pagination-grid ${
                        showCancelledOrdersPagination ? "" : "hide"
                      }`}
                    >
                      <CustomPagination
                        currentpage={paginationCancelledOrdersObj.currentPage}
                        pageSize={paginationCancelledOrdersObj.pageSize}
                        disableNext={false}
                        onChangePageSize={(page: number) => {
                          setPaginationCancelledOrdersObj({
                            ...paginationCancelledOrdersObj,
                            pageSize: Number(page),
                            currentPage: 1,
                          });
                        }}
                        onChangeNextPage={() => {
                          setPaginationCancelledOrdersObj({
                            ...paginationCancelledOrdersObj,
                            currentPage:
                              paginationCancelledOrdersObj.currentPage + 1,
                          });
                        }}
                        onChangeFirstPage={() => {
                          setPaginationCancelledOrdersObj({
                            ...paginationCancelledOrdersObj,
                            currentPage: 1,
                          });
                        }}
                        onChangePreviousPage={() => {
                          setPaginationCancelledOrdersObj({
                            ...paginationCancelledOrdersObj,
                            currentPage:
                              paginationCancelledOrdersObj.currentPage - 1,
                          });
                        }}
                        onChangeLastPage={() => {
                          setPaginationCancelledOrdersObj({
                            ...paginationCancelledOrdersObj,
                            currentPage: totalCancelledOrdersPages || 0,
                          });
                        }}
                        pageSizeSelector={[10, 20, 50]}
                        totalRecords={totalCancelledOrdersRecords || 0}
                      />
                    </div>
                  )}
              </div>
            </div>
          )}

          {selectedTab === 4 && (
            <div className="orderPipeline-return-orders-section">
              <div className="orderPipeline-orders-list">
                <div className="orderPipeline-orders-header">
                  <h3 className="orderPipeline-orders-title">{RETURNS}</h3>
                </div>
                <div className="orderPipeline-orders-content">
                  {!isReturnOrdersLoading &&
                    !isReturnOrdersError &&
                    returnList.length > 0 &&
                    statusLegend()}
                  {isReturnOrdersLoading && (
                    <MotifProgressLoader
                      aria-busy="true"
                      aria-label="This page is loading"
                      aria-live="polite"
                      arialabel="This page is loading"
                      show
                      variant="default"
                      className="home-orderpipeline-progress"
                    />
                  )}
                  {!isReturnOrdersLoading && isReturnOrdersError && (
                    <>
                      <ErrorOrderPage
                        image={productListEmptyImg}
                        header="An error has occurred while attempting to retrieve data. Please choose the option to refresh the page."
                        handleRefresh={() => {
                          setIsReturnOrdersError(false);
                          setPaginationForReturn((prev: any) => ({ ...prev }));
                        }}
                      />
                    </>
                  )}
                  {!isReturnOrdersLoading &&
                    !isReturnOrdersError &&
                    returnList.length >= 0 && (
                      <>
                        <ReturnOrdersTable
                          data={returnList}
                          fetchReturnList={fetchReturnList}
                          removeOrderPipelineQueryParams={
                            removeOrderPipelineQueryParams
                          }
                          columnsData={returnOrdersColumns}
                          setOrders={setReturnList}
                          setShowPagination={setShowReturnOrdersPagination}
                          searchText={debouncedSearchValue}
                          showToastSuccess={(msg) => setToastMessage(msg)}
                          isFilterApplied={!isClearReturnBtnDisabled}
                        />
                        <div className="toast-container">
                          {toastMessage && (
                            <MotifToast
                              onClose={toastCloseHandler}
                              variant="success"
                              position="bottom"
                            >
                              <div slot="toast-supporting-text">
                                {toastMessage}
                              </div>
                            </MotifToast>
                          )}
                        </div>
                      </>
                    )}
                </div>
                {!isReturnOrdersLoading &&
                  !isReturnOrdersError &&
                  returnList.length >= 0 && (
                    <div
                      className={`pagination-grid ${
                        showReturnOrdersPagination ? "" : "hide"
                      }`}
                    >
                      <CustomPagination
                        currentpage={paginationForReturn.currentPage}
                        pageSize={paginationForReturn.pageSize}
                        disableNext={false}
                        onChangePageSize={(page: number) => {
                          setPaginationForReturn({
                            ...paginationForReturn,
                            pageSize: Number(page),
                            currentPage: 1,
                          });
                        }}
                        onChangeNextPage={() => {
                          setPaginationForReturn({
                            ...paginationForReturn,
                            currentPage: paginationForReturn.currentPage + 1,
                          });
                        }}
                        onChangeFirstPage={() => {
                          setPaginationForReturn({
                            ...paginationForReturn,
                            currentPage: 1,
                          });
                        }}
                        onChangePreviousPage={() => {
                          setPaginationForReturn({
                            ...paginationForReturn,
                            currentPage: paginationForReturn.currentPage - 1,
                          });
                        }}
                        onChangeLastPage={() => {
                          setPaginationForReturn({
                            ...paginationForReturn,
                            currentPage: totalReturnPages || 0,
                          });
                        }}
                        pageSizeSelector={[10, 20, 50]}
                        totalRecords={totalReturnRecords || 0}
                      />
                    </div>
                  )}
              </div>
            </div>
          )}

          {selectedTab === 6 && (
            <div className="orderPipeline-orders-section">
              <div className="orderPipeline-orders-list">
                <div className="orderPipeline-orders-header">
                  <div className="motif-row">
                    <div className="motif-col-lg-9">
                      <h3 className="orderPipeline-orders-title">
                        {TRANSACTIONS}
                      </h3>
                      {ordersAutoTransact && ordersAutoTransact.length >= 0 && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <p className="margin-0">
                            {TOTAL_BILLED} :{" "}
                            <span className="order-total">
                              {getTotalRecoveriesAmount(
                                totalBilledAutoTransact,
                              )}
                            </span>
                          </p>
                          <MotifTooltip
                            contentClassName="tooltip-content"
                            hideArrow={false}
                            variant="default"
                            id="tooltip"
                            trigger={
                              <MotifIcon
                                iconFunction={IconoirInfoCircle}
                                size="20"
                                className="motif-tooltip-icon"
                              />
                            }
                          >
                            {TOTAL_BILLED_TOOLTIP}
                          </MotifTooltip>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="orderPipeline-orders-content">
                  {isAutoTransactLoading && (
                    <MotifProgressLoader
                      aria-busy="true"
                      aria-label="This page is loading"
                      aria-live="polite"
                      arialabel="This page is loading"
                      show
                      variant="default"
                      className="home-orderpipeline-progress"
                    />
                  )}
                  {!isAutoTransactLoading && isAutoTransactError && (
                    <ErrorOrderPage
                      image={productListEmptyImg}
                      header="An error has occurred while attempting to retrieve data. Please choose the option to refresh the page."
                      handleRefresh={() => {
                        setIsAutoTransactError(false);
                        setPaginationAutoTransactObj((prev: any) => ({
                          ...prev,
                        }));
                      }}
                    />
                  )}
                  {!isAutoTransactLoading &&
                    !isAutoTransactError &&
                    ordersAutoTransact &&
                    ordersAutoTransact.length >= 0 && (
                      <>
                        <AutoTransactTable
                          data={ordersAutoTransact}
                          setOrdersAutoTransact={setOrdersAutoTransact}
                          columnsData={orderAutoTransactColumns}
                          setShowPagination={setShowAutoTransactPagination}
                          searchText={debouncedSearchValue}
                          isLoading={isAutoTransactLoading}
                          SkuName={selectedSkuName}
                          TransactionStatus={selectedTransactionStatus}
                          ProductName={selectedProductName}
                        />
                        <div
                          className={`pagination-grid ${
                            showAutoTransactPagination ? "" : "hide"
                          }`}
                        >
                          <CustomPagination
                            currentpage={paginationAutoTransactObj.currentPage}
                            pageSize={paginationAutoTransactObj.pageSize}
                            disableNext={false}
                            onChangePageSize={(page: number) => {
                              setPaginationAutoTransactObj({
                                ...paginationAutoTransactObj,
                                pageSize: Number(page),
                                currentPage: 1,
                              });
                            }}
                            onChangeNextPage={() => {
                              setPaginationAutoTransactObj({
                                ...paginationAutoTransactObj,
                                currentPage:
                                  paginationAutoTransactObj.currentPage + 1,
                              });
                            }}
                            onChangeFirstPage={() => {
                              setPaginationAutoTransactObj({
                                ...paginationAutoTransactObj,
                                currentPage: 1,
                              });
                            }}
                            onChangePreviousPage={() => {
                              setPaginationAutoTransactObj({
                                ...paginationAutoTransactObj,
                                currentPage:
                                  paginationAutoTransactObj.currentPage - 1,
                              });
                            }}
                            onChangeLastPage={() => {
                              setPaginationAutoTransactObj({
                                ...paginationAutoTransactObj,
                                currentPage: totalAutoTransactPages || 0,
                              });
                            }}
                            pageSizeSelector={[10, 20, 50]}
                            totalRecords={totalAutoTransactRecords || 0}
                          />
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default OrderPipeline;
